/* tslint:disable:max-line-length semicolon *//*
 * (c) Copyright 2018 e5 Workflow
 *
 * Angular services API generated 2/6/2019, 5:37:18 PM.
    */
   import { Injectable } from '@angular/core';
   import { HttpClient, HttpParams } from '@angular/common/http';
   import { Observable } from 'rxjs';
   import { E5ConfigurationService as e5Config } from './e5.configuration.service';
   import * as e5Models from '../models/e5.data.models';


@Injectable()
export class ConfigurationInstanceService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /api/Configuration/Instance?api-version=1.0
    public getAll(): Observable<e5Models.ConfigurationInstanceModel[]> {

        return this.http.get<e5Models.ConfigurationInstanceModel[]>(`${this.baseUrl}/api/Configuration/Instance` );
    }

    // GET /api/Configuration/Instance/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.ConfigurationInstanceModel> {

        return this.http.get<e5Models.ConfigurationInstanceModel>(`${this.baseUrl}/api/Configuration/Instance/${id}` );
    }

}


@Injectable()
export class ConfigurationScopeService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // DELETE /api/Configuration/Scope?key={key}&api-version=1.0
    public delete( options?: { key ?: any}): Observable<Object> {
        let params = new HttpParams();
        if (options && typeof(options.key) !== 'undefined') { params = params.append('key', options.key); }

        return this.http.delete<Object>(`${this.baseUrl}/api/Configuration/Scope` , { params: params });
    }

    // GET /api/Configuration/Scope?api-version=1.0
    public getAll(): Observable<e5Models.ConfigurationScopeModel[]> {

        return this.http.get<e5Models.ConfigurationScopeModel[]>(`${this.baseUrl}/api/Configuration/Scope` );
    }

    // POST /api/Configuration/Scope?key={key}&api-version=1.0
    public create(postJson: any, options?: { key ?: any}): Observable<e5Models.ConfigurationSettingModel> {
        let params = new HttpParams();
        if (options && typeof(options.key) !== 'undefined') { params = params.append('key', options.key); }

        return this.http.post<e5Models.ConfigurationSettingModel>(`${this.baseUrl}/api/Configuration/Scope`, postJson , { params: params });
    }

    // GET /api/Configuration/Scope/{key}?api-version=1.0
    public get(key: any): Observable<e5Models.ConfigurationScopeModel> {

        return this.http.get<e5Models.ConfigurationScopeModel>(`${this.baseUrl}/api/Configuration/Scope/${key}` );
    }

}


@Injectable()
export class ConfigurationSectionService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /api/Configuration/Section?api-version=1.0
    public getAll(): Observable<e5Models.ConfigurationSectionModel[]> {

        return this.http.get<e5Models.ConfigurationSectionModel[]>(`${this.baseUrl}/api/Configuration/Section` );
    }

    // POST /api/Configuration/Section/Create?api-version=1.0
    public create(postJson: any): Observable<e5Models.ConfigurationSectionModel> {

        return this.http.post<e5Models.ConfigurationSectionModel>(`${this.baseUrl}/api/Configuration/Section/Create`, postJson );
    }

    // GET /api/Configuration/Section/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.ConfigurationSectionModel> {

        return this.http.get<e5Models.ConfigurationSectionModel>(`${this.baseUrl}/api/Configuration/Section/${id}` );
    }

}


@Injectable()
export class ConfigurationSettingService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /api/Configuration/Setting?api-version=1.0
    public getAll(): Observable<e5Models.ConfigurationSettingModel[]> {

        return this.http.get<e5Models.ConfigurationSettingModel[]>(`${this.baseUrl}/api/Configuration/Setting` );
    }

    // POST /api/Configuration/Setting?api-version=1.0
    public create(postJson: any): Observable<e5Models.ConfigurationSettingModel> {

        return this.http.post<e5Models.ConfigurationSettingModel>(`${this.baseUrl}/api/Configuration/Setting`, postJson );
    }

    // GET /api/Configuration/Setting/{application}/{section}/{key}?api-version=1.0
    public getFilteredSetting(application: any, section: any, key: any): Observable<e5Models.ConfigurationSettingModel[]> {

        return this.http.get<e5Models.ConfigurationSettingModel[]>(`${this.baseUrl}/api/Configuration/Setting/${application}/${section}/${key}` );
    }

    // GET /api/Configuration/Setting/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.ConfigurationSettingModel> {

        return this.http.get<e5Models.ConfigurationSettingModel>(`${this.baseUrl}/api/Configuration/Setting/${id}` );
    }

    // PUT /api/Configuration/Setting/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.ConfigurationSettingModel> {

        return this.http.put<e5Models.ConfigurationSettingModel>(`${this.baseUrl}/api/Configuration/Setting/${id}`, putJson );
    }

}


@Injectable()
export class IdentityClaimService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Identity/Claim/GetClaimsForCurrentUser?type={type}&issuer={issuer}&api-version=1.0
    public getClaimsForCurrentUser( options?: { type ?: any, issuer ?: any}): Observable<e5Models.ClaimModel[]> {
        let params = new HttpParams();
        if (options && typeof(options.type) !== 'undefined') { params = params.append('type', options.type); }
        if (options && typeof(options.issuer) !== 'undefined') { params = params.append('issuer', options.issuer); }

        return this.http.get<e5Models.ClaimModel[]>(`${this.baseUrl}/${this.scope}/api/Identity/Claim/GetClaimsForCurrentUser` , { params: params });
    }

    // GET /{scope}/api/Identity/Claim/GetClaimsForUser?sub={sub}&type={type}&issuer={issuer}&api-version=1.0
    public getClaimsForUser( options?: { sub ?: any, type ?: any, issuer ?: any}): Observable<e5Models.ClaimModel[]> {
        let params = new HttpParams();
        if (options && typeof(options.sub) !== 'undefined') { params = params.append('sub', options.sub); }
        if (options && typeof(options.type) !== 'undefined') { params = params.append('type', options.type); }
        if (options && typeof(options.issuer) !== 'undefined') { params = params.append('issuer', options.issuer); }

        return this.http.get<e5Models.ClaimModel[]>(`${this.baseUrl}/${this.scope}/api/Identity/Claim/GetClaimsForUser` , { params: params });
    }

    // GET /{scope}/api/Identity/Claim/GetGroupsForUser?sub={sub}&api-version=1.0
    public getGroupsForUser( options?: { sub ?: any}): Observable<e5Models.ClaimModel[]> {
        let params = new HttpParams();
        if (options && typeof(options.sub) !== 'undefined') { params = params.append('sub', options.sub); }

        return this.http.get<e5Models.ClaimModel[]>(`${this.baseUrl}/${this.scope}/api/Identity/Claim/GetGroupsForUser` , { params: params });
    }

}


@Injectable()
export class IdentityUserProfileService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Identity/UserProfile/GetProfileForCurrentUser?api-version=1.0
    public getProfileForCurrentUser(): Observable<e5Models.UserProfileModel> {

        return this.http.get<e5Models.UserProfileModel>(`${this.baseUrl}/${this.scope}/api/Identity/UserProfile/GetProfileForCurrentUser` );
    }

}


@Injectable()
export class IdentityUserSessionService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // POST /{scope}/api/Identity/UserSession/ClearCurrentUserClaims?api-version=1.0
    public clearCurrentUserClaims(): Observable<e5Models.ConfigurationSettingModel> {

        return this.http.post<e5Models.ConfigurationSettingModel>(`${this.baseUrl}/${this.scope}/api/Identity/UserSession/ClearCurrentUserClaims`, null );
    }

    // POST /{scope}/api/Identity/UserSession/ClearCurrentUserSession?api-version=1.0
    public clearCurrentUserSession(): Observable<e5Models.ConfigurationSettingModel> {

        return this.http.post<e5Models.ConfigurationSettingModel>(`${this.baseUrl}/${this.scope}/api/Identity/UserSession/ClearCurrentUserSession`, null );
    }

    // GET /{scope}/api/Identity/UserSession/GetClaimsForCurrentUser?type={type}&issuer={issuer}&api-version=1.0
    public getClaimsForCurrentUser( options?: { type ?: any, issuer ?: any}): Observable<e5Models.ClaimModel[]> {
        let params = new HttpParams();
        if (options && typeof(options.type) !== 'undefined') { params = params.append('type', options.type); }
        if (options && typeof(options.issuer) !== 'undefined') { params = params.append('issuer', options.issuer); }

        return this.http.get<e5Models.ClaimModel[]>(`${this.baseUrl}/${this.scope}/api/Identity/UserSession/GetClaimsForCurrentUser` , { params: params });
    }

    // GET /{scope}/api/Identity/UserSession/GetScopeForCurrentUser?api-version=1.0
    public getScopeForCurrentUser(): Observable<e5Models.ConfigurationScopeModel> {

        return this.http.get<e5Models.ConfigurationScopeModel>(`${this.baseUrl}/${this.scope}/api/Identity/UserSession/GetScopeForCurrentUser` );
    }

}


@Injectable()
export class IntegrationSiteService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Integration/Site/GetAllGroups?api-version=1.0
    public getAllGroups(): Observable<e5Models.ClaimModel[]> {

        return this.http.get<e5Models.ClaimModel[]>(`${this.baseUrl}/${this.scope}/api/Integration/Site/GetAllGroups` );
    }

    // GET /{scope}/api/Integration/Site/GetGroupsForCurrentUser?api-version=1.0
    public getGroupsForCurrentUser(): Observable<e5Models.ClaimModel[]> {

        return this.http.get<e5Models.ClaimModel[]>(`${this.baseUrl}/${this.scope}/api/Integration/Site/GetGroupsForCurrentUser` );
    }

    // GET /{scope}/api/Integration/Site/GetGroupsForUser?sub={sub}&api-version=1.0
    public getGroupsForUser( options?: { sub ?: any}): Observable<e5Models.ClaimModel[]> {
        let params = new HttpParams();
        if (options && typeof(options.sub) !== 'undefined') { params = params.append('sub', options.sub); }

        return this.http.get<e5Models.ClaimModel[]>(`${this.baseUrl}/${this.scope}/api/Integration/Site/GetGroupsForUser` , { params: params });
    }

}


@Injectable()
export class IntegrationYammerMessagesService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // POST /{scope}/api/Integration/Yammer/YammerMessages/PostMessage?message={message}&groups={groups}&topics={topics}&action={action}&api-version=1.0
    public postMessage( options?: { message ?: any, groups ?: any, topics ?: any, action ?: any}): Observable<e5Models.IntegrationYammerYammerPostModel[]> {
        let params = new HttpParams();
        if (options && typeof(options.message) !== 'undefined') { params = params.append('message', options.message); }
        if (options && typeof(options.groups) !== 'undefined') { params = params.append('groups', options.groups); }
        if (options && typeof(options.topics) !== 'undefined') { params = params.append('topics', options.topics); }
        if (options && typeof(options.action) !== 'undefined') { params = params.append('action', options.action); }

        return this.http.post<e5Models.IntegrationYammerYammerPostModel[]>(`${this.baseUrl}/${this.scope}/api/Integration/Yammer/YammerMessages/PostMessage`, null , { params: params });
    }

    // POST /{scope}/api/Integration/Yammer/YammerMessages/PostWorkItemMessage/{workId}?message={message}&groups={groups}&topics={topics}&action={action}&api-version=1.0
    public postWorkItemMessage(workId: any, options?: { message ?: any, groups ?: any, topics ?: any, action ?: any}): Observable<e5Models.IntegrationYammerYammerPostModel[]> {
        let params = new HttpParams();
        if (options && typeof(options.message) !== 'undefined') { params = params.append('message', options.message); }
        if (options && typeof(options.groups) !== 'undefined') { params = params.append('groups', options.groups); }
        if (options && typeof(options.topics) !== 'undefined') { params = params.append('topics', options.topics); }
        if (options && typeof(options.action) !== 'undefined') { params = params.append('action', options.action); }

        return this.http.post<e5Models.IntegrationYammerYammerPostModel[]>(`${this.baseUrl}/${this.scope}/api/Integration/Yammer/YammerMessages/PostWorkItemMessage/${workId}`, null , { params: params });
    }

}


@Injectable()
export class IntegrationYammerTopicsService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /api/Integration/Yammer/YammerTopics?topic={topic}&api-version=1.0
    public getAll( options?: { topic ?: any}): Observable<e5Models.IntegrationYammerYammerTopicModel> {
        let params = new HttpParams();
        if (options && typeof(options.topic) !== 'undefined') { params = params.append('topic', options.topic); }

        return this.http.get<e5Models.IntegrationYammerYammerTopicModel>(`${this.baseUrl}/api/Integration/Yammer/YammerTopics` , { params: params });
    }

    // GET /api/Integration/Yammer/YammerTopics/Exists?topic={topic}&api-version=1.0
    public exists( options?: { topic ?: any}): Observable<Object> {
        let params = new HttpParams();
        if (options && typeof(options.topic) !== 'undefined') { params = params.append('topic', options.topic); }

        return this.http.get<Object>(`${this.baseUrl}/api/Integration/Yammer/YammerTopics/Exists` , { params: params });
    }

}


@Injectable()
export class ListSearchService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/List/Search/{id}?prefix={prefix}&parentListItemId={parentListItemId}&api-version=1.0
    public search(id: any, options?: { prefix ?: any, parentListItemId ?: any}): Observable<e5Models.ListItemModel[]> {
        let params = new HttpParams();
        if (options && typeof(options.prefix) !== 'undefined') { params = params.append('prefix', options.prefix); }
        if (options && typeof(options.parentListItemId) !== 'undefined') { params = params.append('parentListItemId', options.parentListItemId); }

        return this.http.get<e5Models.ListItemModel[]>(`${this.baseUrl}/${this.scope}/api/List/Search/${id}` , { params: params });
    }

}


@Injectable()
export class MonitorsSlaCompletionMonitorService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Monitors/SlaCompletionMonitor/GetCompletionSlaMonitorWorkCounts/{startDate}/{endDate}?category1Id={category1Id}&siteGroup={siteGroup}&category2Id={category2Id}&category3Id={category3Id}&archive={archive}&totalProperty={totalProperty}&api-version=1.0
    public getCompletionSlaMonitorWorkCounts(startDate: any, endDate: any, options?: { category1Id ?: any, siteGroup ?: any, category2Id ?: any, category3Id ?: any, archive ?: any, totalProperty ?: any}): Observable<e5Models.MonitorsSlaCompletionMonitorModel> {
        let params = new HttpParams();
        if (options && typeof(options.category1Id) !== 'undefined') { params = params.append('category1Id', options.category1Id); }
        if (options && typeof(options.siteGroup) !== 'undefined') { params = params.append('siteGroup', options.siteGroup); }
        if (options && typeof(options.category2Id) !== 'undefined') { params = params.append('category2Id', options.category2Id); }
        if (options && typeof(options.category3Id) !== 'undefined') { params = params.append('category3Id', options.category3Id); }
        if (options && typeof(options.archive) !== 'undefined') { params = params.append('archive', options.archive); }
        if (options && typeof(options.totalProperty) !== 'undefined') { params = params.append('totalProperty', options.totalProperty); }

        return this.http.get<e5Models.MonitorsSlaCompletionMonitorModel>(`${this.baseUrl}/${this.scope}/api/Monitors/SlaCompletionMonitor/GetCompletionSlaMonitorWorkCounts/${startDate}/${endDate}` , { params: params });
    }

}


@Injectable()
export class MonitorsSlaInflowsMonitorService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Monitors/SlaInflowsMonitor/GetInflowsSlaMonitorWorkCounts?endDate={endDate}&archive={archive}&siteGroup={siteGroup}&startDate={startDate}&category1Id={category1Id}&category2Id={category2Id}&category3Id={category3Id}&otherWorkStatus={otherWorkStatus}&api-version=1.0
    public getInflowsSlaMonitorWorkCounts( options?: { endDate ?: any, archive ?: any, siteGroup ?: any, startDate ?: any, category1Id ?: any, category2Id ?: any, category3Id ?: any, otherWorkStatus ?: any}): Observable<e5Models.MonitorsSlaInflowsMonitorModel> {
        let params = new HttpParams();
        if (options && typeof(options.endDate) !== 'undefined') { params = params.append('endDate', options.endDate); }
        if (options && typeof(options.archive) !== 'undefined') { params = params.append('archive', options.archive); }
        if (options && typeof(options.siteGroup) !== 'undefined') { params = params.append('siteGroup', options.siteGroup); }
        if (options && typeof(options.startDate) !== 'undefined') { params = params.append('startDate', options.startDate); }
        if (options && typeof(options.category1Id) !== 'undefined') { params = params.append('category1Id', options.category1Id); }
        if (options && typeof(options.category2Id) !== 'undefined') { params = params.append('category2Id', options.category2Id); }
        if (options && typeof(options.category3Id) !== 'undefined') { params = params.append('category3Id', options.category3Id); }
        if (options && typeof(options.otherWorkStatus) !== 'undefined') { params = params.append('otherWorkStatus', options.otherWorkStatus); }

        return this.http.get<e5Models.MonitorsSlaInflowsMonitorModel>(`${this.baseUrl}/${this.scope}/api/Monitors/SlaInflowsMonitor/GetInflowsSlaMonitorWorkCounts` , { params: params });
    }

}


@Injectable()
export class MonitorsSlaInventoryMonitorService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Monitors/SlaInventoryMonitor/GetInventorySlaMonitorWorkCounts/{startDate}/{endDate}?category3Id={category3Id}&category1Id={category1Id}&category2Id={category2Id}&stauses={stauses}&calculatedIntervals={calculatedIntervals}&concatPivotFields={concatPivotFields}&debug={debug}&api-version=1.0
    public getInventorySlaMonitorWorkCounts(startDate: any, endDate: any, options?: { category3Id ?: any, category1Id ?: any, category2Id ?: any, stauses ?: any, calculatedIntervals ?: any, concatPivotFields ?: any, debug ?: any}): Observable<e5Models.MonitorsSlaInventoryMonitorModel> {
        let params = new HttpParams();
        if (options && typeof(options.category3Id) !== 'undefined') { params = params.append('category3Id', options.category3Id); }
        if (options && typeof(options.category1Id) !== 'undefined') { params = params.append('category1Id', options.category1Id); }
        if (options && typeof(options.category2Id) !== 'undefined') { params = params.append('category2Id', options.category2Id); }
        if (options && typeof(options.stauses) !== 'undefined') { params = params.append('stauses', options.stauses); }
        if (options && typeof(options.calculatedIntervals) !== 'undefined') { params = params.append('calculatedIntervals', options.calculatedIntervals); }
        if (options && typeof(options.concatPivotFields) !== 'undefined') { params = params.append('concatPivotFields', options.concatPivotFields); }
        if (options && typeof(options.debug) !== 'undefined') { params = params.append('debug', options.debug); }

        return this.http.get<e5Models.MonitorsSlaInventoryMonitorModel>(`${this.baseUrl}/${this.scope}/api/Monitors/SlaInventoryMonitor/GetInventorySlaMonitorWorkCounts/${startDate}/${endDate}` , { params: params });
    }

}


@Injectable()
export class MonitorsSlaMonitorService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Monitors/SlaMonitor/GetSlaMonitorWorkCounts/{category1Id}/{category2Id}/{category3Id}/{categoryActivityId}?showEmptyCategories={showEmptyCategories}&approachingSLARange={approachingSLARange}&isApproachingSLAInHours={isApproachingSLAInHours}&statuses={statuses}&includeInactive={includeInactive}&isDebug={isDebug}&assignedUser={assignedUser}&siteGroupFilters={siteGroupFilters}&followUser={followUser}&totalProperty={totalProperty}&filterPropertyId={filterPropertyId}&filterPropertyValue={filterPropertyValue}&showSlaMode={showSlaMode}&api-version=1.0
    public getSlaMonitorWorkCounts(category1Id: any, category2Id: any, category3Id: any, categoryActivityId: any, options?: { showEmptyCategories ?: any, approachingSLARange ?: any, isApproachingSLAInHours ?: any, statuses ?: any, includeInactive ?: any, isDebug ?: any, assignedUser ?: any, siteGroupFilters ?: any, followUser ?: any, totalProperty ?: any, filterPropertyId ?: any, filterPropertyValue ?: any, showSlaMode ?: any}): Observable<e5Models.MonitorsSlaMonitorModel> {
        let params = new HttpParams();
        if (options && typeof(options.showEmptyCategories) !== 'undefined') { params = params.append('showEmptyCategories', options.showEmptyCategories); }
        if (options && typeof(options.approachingSLARange) !== 'undefined') { params = params.append('approachingSLARange', options.approachingSLARange); }
        if (options && typeof(options.isApproachingSLAInHours) !== 'undefined') { params = params.append('isApproachingSLAInHours', options.isApproachingSLAInHours); }
        if (options && typeof(options.statuses) !== 'undefined') { params = params.append('statuses', options.statuses); }
        if (options && typeof(options.includeInactive) !== 'undefined') { params = params.append('includeInactive', options.includeInactive); }
        if (options && typeof(options.isDebug) !== 'undefined') { params = params.append('isDebug', options.isDebug); }
        if (options && typeof(options.assignedUser) !== 'undefined') { params = params.append('assignedUser', options.assignedUser); }
        if (options && typeof(options.siteGroupFilters) !== 'undefined') { params = params.append('siteGroupFilters', options.siteGroupFilters); }
        if (options && typeof(options.followUser) !== 'undefined') { params = params.append('followUser', options.followUser); }
        if (options && typeof(options.totalProperty) !== 'undefined') { params = params.append('totalProperty', options.totalProperty); }
        if (options && typeof(options.filterPropertyId) !== 'undefined') { params = params.append('filterPropertyId', options.filterPropertyId); }
        if (options && typeof(options.filterPropertyValue) !== 'undefined') { params = params.append('filterPropertyValue', options.filterPropertyValue); }
        if (options && typeof(options.showSlaMode) !== 'undefined') { params = params.append('showSlaMode', options.showSlaMode); }

        return this.http.get<e5Models.MonitorsSlaMonitorModel>(`${this.baseUrl}/${this.scope}/api/Monitors/SlaMonitor/GetSlaMonitorWorkCounts/${category1Id}/${category2Id}/${category3Id}/${categoryActivityId}` , { params: params });
    }

}


@Injectable()
export class MonitorsSlaTeamProductivityCompletionMonitorService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Monitors/SlaTeamProductivityCompletionMonitor/GetTeamProductivityCompletionSlaMonitorWorkCounts/{startDate}/{endDate}?category3Id={category3Id}&category1Id={category1Id}&category2Id={category2Id}&stauses={stauses}&calculatedIntervals={calculatedIntervals}&userGroupsId={userGroupsId}&concatPivotFields={concatPivotFields}&debug={debug}&api-version=1.0
    public getTeamProductivityCompletionSlaMonitorWorkCounts(startDate: any, endDate: any, options?: { category3Id ?: any, category1Id ?: any, category2Id ?: any, stauses ?: any, calculatedIntervals ?: any, userGroupsId ?: any, concatPivotFields ?: any, debug ?: any}): Observable<e5Models.MonitorsSlaTeamProductivityCompletionMonitorModel> {
        let params = new HttpParams();
        if (options && typeof(options.category3Id) !== 'undefined') { params = params.append('category3Id', options.category3Id); }
        if (options && typeof(options.category1Id) !== 'undefined') { params = params.append('category1Id', options.category1Id); }
        if (options && typeof(options.category2Id) !== 'undefined') { params = params.append('category2Id', options.category2Id); }
        if (options && typeof(options.stauses) !== 'undefined') { params = params.append('stauses', options.stauses); }
        if (options && typeof(options.calculatedIntervals) !== 'undefined') { params = params.append('calculatedIntervals', options.calculatedIntervals); }
        if (options && typeof(options.userGroupsId) !== 'undefined') { params = params.append('userGroupsId', options.userGroupsId); }
        if (options && typeof(options.concatPivotFields) !== 'undefined') { params = params.append('concatPivotFields', options.concatPivotFields); }
        if (options && typeof(options.debug) !== 'undefined') { params = params.append('debug', options.debug); }

        return this.http.get<e5Models.MonitorsSlaTeamProductivityCompletionMonitorModel>(`${this.baseUrl}/${this.scope}/api/Monitors/SlaTeamProductivityCompletionMonitor/GetTeamProductivityCompletionSlaMonitorWorkCounts/${startDate}/${endDate}` , { params: params });
    }

}


@Injectable()
export class MonitorsSlaTeamProductivityFacetimeMonitorService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Monitors/SlaTeamProductivityFacetimeMonitor/GetTeamProductivityFacetimeSlaMonitorWorkCounts/{startDate}/{endDate}?category3Id={category3Id}&category1Id={category1Id}&category2Id={category2Id}&stauses={stauses}&calculatedIntervals={calculatedIntervals}&userGroupsId={userGroupsId}&concatPivotFields={concatPivotFields}&debug={debug}&api-version=1.0
    public getTeamProductivityFacetimeSlaMonitorWorkCounts(startDate: any, endDate: any, options?: { category3Id ?: any, category1Id ?: any, category2Id ?: any, stauses ?: any, calculatedIntervals ?: any, userGroupsId ?: any, concatPivotFields ?: any, debug ?: any}): Observable<e5Models.MonitorsSlaTeamProductivityFacetimeMonitorModel> {
        let params = new HttpParams();
        if (options && typeof(options.category3Id) !== 'undefined') { params = params.append('category3Id', options.category3Id); }
        if (options && typeof(options.category1Id) !== 'undefined') { params = params.append('category1Id', options.category1Id); }
        if (options && typeof(options.category2Id) !== 'undefined') { params = params.append('category2Id', options.category2Id); }
        if (options && typeof(options.stauses) !== 'undefined') { params = params.append('stauses', options.stauses); }
        if (options && typeof(options.calculatedIntervals) !== 'undefined') { params = params.append('calculatedIntervals', options.calculatedIntervals); }
        if (options && typeof(options.userGroupsId) !== 'undefined') { params = params.append('userGroupsId', options.userGroupsId); }
        if (options && typeof(options.concatPivotFields) !== 'undefined') { params = params.append('concatPivotFields', options.concatPivotFields); }
        if (options && typeof(options.debug) !== 'undefined') { params = params.append('debug', options.debug); }

        return this.http.get<e5Models.MonitorsSlaTeamProductivityFacetimeMonitorModel>(`${this.baseUrl}/${this.scope}/api/Monitors/SlaTeamProductivityFacetimeMonitor/GetTeamProductivityFacetimeSlaMonitorWorkCounts/${startDate}/${endDate}` , { params: params });
    }

}


@Injectable()
export class TaxonomyActivityDefinitionCheckService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/ActivityDefinition/Check?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyActivityDefinitionModel[]> {

        return this.http.get<e5Models.TaxonomyActivityDefinitionModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ActivityDefinition/Check` );
    }

    // POST /{scope}/api/Taxonomy/ActivityDefinition/Check?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyActivityDefinitionModel> {

        return this.http.post<e5Models.TaxonomyActivityDefinitionModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ActivityDefinition/Check`, postJson );
    }

    // GET /{scope}/api/Taxonomy/ActivityDefinition/Check/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyActivityDefinitionModel> {

        return this.http.get<e5Models.TaxonomyActivityDefinitionModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ActivityDefinition/Check/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/ActivityDefinition/Check/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyActivityDefinitionModel> {

        return this.http.put<e5Models.TaxonomyActivityDefinitionModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ActivityDefinition/Check/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyActivityDefinitionContentTypeService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/ActivityDefinition/ContentType?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyActivityDefinitionContentTypeModel[]> {

        return this.http.get<e5Models.TaxonomyActivityDefinitionContentTypeModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ActivityDefinition/ContentType` );
    }

    // POST /{scope}/api/Taxonomy/ActivityDefinition/ContentType?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyActivityDefinitionContentTypeModel> {

        return this.http.post<e5Models.TaxonomyActivityDefinitionContentTypeModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ActivityDefinition/ContentType`, postJson );
    }

    // GET /{scope}/api/Taxonomy/ActivityDefinition/ContentType/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyActivityDefinitionContentTypeModel> {

        return this.http.get<e5Models.TaxonomyActivityDefinitionContentTypeModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ActivityDefinition/ContentType/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/ActivityDefinition/ContentType/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyActivityDefinitionContentTypeModel> {

        return this.http.put<e5Models.TaxonomyActivityDefinitionContentTypeModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ActivityDefinition/ContentType/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyActivityDefinitionProcessService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/ActivityDefinition/Process?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyActivityDefinitionModel[]> {

        return this.http.get<e5Models.TaxonomyActivityDefinitionModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ActivityDefinition/Process` );
    }

    // POST /{scope}/api/Taxonomy/ActivityDefinition/Process?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyActivityDefinitionModel> {

        return this.http.post<e5Models.TaxonomyActivityDefinitionModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ActivityDefinition/Process`, postJson );
    }

    // GET /{scope}/api/Taxonomy/ActivityDefinition/Process/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyActivityDefinitionModel> {

        return this.http.get<e5Models.TaxonomyActivityDefinitionModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ActivityDefinition/Process/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/ActivityDefinition/Process/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyActivityDefinitionModel> {

        return this.http.put<e5Models.TaxonomyActivityDefinitionModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ActivityDefinition/Process/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyAdapterService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/Adapter?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyAdapterModel[]> {

        return this.http.get<e5Models.TaxonomyAdapterModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Adapter` );
    }

    // POST /{scope}/api/Taxonomy/Adapter?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyAdapterModel> {

        return this.http.post<e5Models.TaxonomyAdapterModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Adapter`, postJson );
    }

    // GET /{scope}/api/Taxonomy/Adapter/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyAdapterModel> {

        return this.http.get<e5Models.TaxonomyAdapterModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Adapter/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/Adapter/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyAdapterModel> {

        return this.http.put<e5Models.TaxonomyAdapterModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Adapter/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyAttachmentTypeService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/AttachmentType?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyAttachmentTypeModel[]> {

        return this.http.get<e5Models.TaxonomyAttachmentTypeModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/AttachmentType` );
    }

    // POST /{scope}/api/Taxonomy/AttachmentType?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyAttachmentTypeCreateModel> {

        return this.http.post<e5Models.TaxonomyAttachmentTypeCreateModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/AttachmentType`, postJson );
    }

    // GET /{scope}/api/Taxonomy/AttachmentType/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyAttachmentTypeModel> {

        return this.http.get<e5Models.TaxonomyAttachmentTypeModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/AttachmentType/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/AttachmentType/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyAttachmentTypeModel> {

        return this.http.put<e5Models.TaxonomyAttachmentTypeModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/AttachmentType/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyAttachmentTypeRoleService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/AttachmentTypeRole?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyAttachmentTypeRoleModel[]> {

        return this.http.get<e5Models.TaxonomyAttachmentTypeRoleModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/AttachmentTypeRole` );
    }

    // POST /{scope}/api/Taxonomy/AttachmentTypeRole?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyAttachmentTypeRoleModel> {

        return this.http.post<e5Models.TaxonomyAttachmentTypeRoleModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/AttachmentTypeRole`, postJson );
    }

    // PUT /{scope}/api/Taxonomy/AttachmentTypeRole?api-version=1.0
    public update(putJson: any): Observable<e5Models.TaxonomyAttachmentTypeRoleModel> {

        return this.http.put<e5Models.TaxonomyAttachmentTypeRoleModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/AttachmentTypeRole`, putJson );
    }

}


@Injectable()
export class TaxonomyCaseNoteTypeService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/CaseNoteType?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyCaseNoteTypeModel[]> {

        return this.http.get<e5Models.TaxonomyCaseNoteTypeModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CaseNoteType` );
    }

    // POST /{scope}/api/Taxonomy/CaseNoteType?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyCaseNoteTypeModel> {

        return this.http.post<e5Models.TaxonomyCaseNoteTypeModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CaseNoteType`, postJson );
    }

    // GET /{scope}/api/Taxonomy/CaseNoteType/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyCaseNoteTypeModel> {

        return this.http.get<e5Models.TaxonomyCaseNoteTypeModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CaseNoteType/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/CaseNoteType/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyCaseNoteTypeModel> {

        return this.http.put<e5Models.TaxonomyCaseNoteTypeModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CaseNoteType/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyCategory1Service {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/Category1?isActive={isActive}&api-version=1.0
    public getAll( options?: { isActive ?: any}): Observable<e5Models.TaxonomyCategory1Model[]> {
        let params = new HttpParams();
        if (options && typeof(options.isActive) !== 'undefined') { params = params.append('isActive', options.isActive); }

        return this.http.get<e5Models.TaxonomyCategory1Model[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Category1` , { params: params });
    }

    // POST /{scope}/api/Taxonomy/Category1?addToSite={addToSite}&api-version=1.0
    public create(postJson: any, options?: { addToSite ?: any}): Observable<e5Models.TaxonomyCategory1Model> {
        let params = new HttpParams();
        if (options && typeof(options.addToSite) !== 'undefined') { params = params.append('addToSite', options.addToSite); }

        return this.http.post<e5Models.TaxonomyCategory1Model>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Category1`, postJson , { params: params });
    }

    // GET /{scope}/api/Taxonomy/Category1/{id}?isActive={isActive}&api-version=1.0
    public get(id: any, options?: { isActive ?: any}): Observable<e5Models.TaxonomyCategory1Model> {
        let params = new HttpParams();
        if (options && typeof(options.isActive) !== 'undefined') { params = params.append('isActive', options.isActive); }

        return this.http.get<e5Models.TaxonomyCategory1Model>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Category1/${id}` , { params: params });
    }

    // PUT /{scope}/api/Taxonomy/Category1/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyCategory1Model> {

        return this.http.put<e5Models.TaxonomyCategory1Model>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Category1/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyCategory2Service {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // POST /{scope}/api/Taxonomy/Category2?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyCategory2Model> {

        return this.http.post<e5Models.TaxonomyCategory2Model>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Category2`, postJson );
    }

    // GET /{scope}/api/Taxonomy/Category2/GetFromCache/{category1Id}?isActive={isActive}&api-version=1.0
    public getFromCache(category1Id: any, options?: { isActive ?: any}): Observable<e5Models.TaxonomyCategory2Model[]> {
        let params = new HttpParams();
        if (options && typeof(options.isActive) !== 'undefined') { params = params.append('isActive', options.isActive); }

        return this.http.get<e5Models.TaxonomyCategory2Model[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Category2/GetFromCache/${category1Id}` , { params: params });
    }

    // GET /{scope}/api/Taxonomy/Category2/{category1Id}?isActive={isActive}&api-version=1.0
    public getAll(category1Id: any, options?: { isActive ?: any}): Observable<e5Models.TaxonomyCategory2Model[]> {
        let params = new HttpParams();
        if (options && typeof(options.isActive) !== 'undefined') { params = params.append('isActive', options.isActive); }

        return this.http.get<e5Models.TaxonomyCategory2Model[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Category2/${category1Id}` , { params: params });
    }

    // PUT /{scope}/api/Taxonomy/Category2/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyCategory2Model> {

        return this.http.put<e5Models.TaxonomyCategory2Model>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Category2/${id}`, putJson );
    }

    // GET /{scope}/api/Taxonomy/Category2/{id}/{category1Id}?isActive={isActive}&api-version=1.0
    public get(id: any, category1Id: any, options?: { isActive ?: any}): Observable<e5Models.TaxonomyCategory2Model> {
        let params = new HttpParams();
        if (options && typeof(options.isActive) !== 'undefined') { params = params.append('isActive', options.isActive); }

        return this.http.get<e5Models.TaxonomyCategory2Model>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Category2/${id}/${category1Id}` , { params: params });
    }

}


@Injectable()
export class TaxonomyCategory3Service {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // POST /{scope}/api/Taxonomy/Category3?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyCategory3Model> {

        return this.http.post<e5Models.TaxonomyCategory3Model>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Category3`, postJson );
    }

    // GET /{scope}/api/Taxonomy/Category3/{category1Id}/{category2Id}?isActive={isActive}&api-version=1.0
    public getAll(category1Id: any, category2Id: any, options?: { isActive ?: any}): Observable<e5Models.TaxonomyCategory3Model[]> {
        let params = new HttpParams();
        if (options && typeof(options.isActive) !== 'undefined') { params = params.append('isActive', options.isActive); }

        return this.http.get<e5Models.TaxonomyCategory3Model[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Category3/${category1Id}/${category2Id}` , { params: params });
    }

    // PUT /{scope}/api/Taxonomy/Category3/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyCategory3Model> {

        return this.http.put<e5Models.TaxonomyCategory3Model>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Category3/${id}`, putJson );
    }

    // GET /{scope}/api/Taxonomy/Category3/{id}/{category1Id}/{category2Id}?isActive={isActive}&api-version=1.0
    public get(id: any, category1Id: any, category2Id: any, options?: { isActive ?: any}): Observable<e5Models.TaxonomyCategory3Model> {
        let params = new HttpParams();
        if (options && typeof(options.isActive) !== 'undefined') { params = params.append('isActive', options.isActive); }

        return this.http.get<e5Models.TaxonomyCategory3Model>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Category3/${id}/${category1Id}/${category2Id}` , { params: params });
    }

}


@Injectable()
export class TaxonomyCategoryActivityAttributeService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/CategoryActivityAttribute?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyCategoryActivityAttributeModel[]> {

        return this.http.get<e5Models.TaxonomyCategoryActivityAttributeModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityAttribute` );
    }

    // POST /{scope}/api/Taxonomy/CategoryActivityAttribute?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyCategoryActivityAttributeModel> {

        return this.http.post<e5Models.TaxonomyCategoryActivityAttributeModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityAttribute`, postJson );
    }

    // GET /{scope}/api/Taxonomy/CategoryActivityAttribute/GetByCategoryActivityId/{categoryActivityId}?api-version=1.0
    public getByCategoryActivityId(categoryActivityId: any): Observable<e5Models.TaxonomyCategoryActivityAttributeModel> {

        return this.http.get<e5Models.TaxonomyCategoryActivityAttributeModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityAttribute/GetByCategoryActivityId/${categoryActivityId}` );
    }

    // GET /{scope}/api/Taxonomy/CategoryActivityAttribute/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyCategoryActivityAttributeModel> {

        return this.http.get<e5Models.TaxonomyCategoryActivityAttributeModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityAttribute/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/CategoryActivityAttribute/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyCategoryActivityAttributeModel> {

        return this.http.put<e5Models.TaxonomyCategoryActivityAttributeModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityAttribute/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyCategoryActivityDefinitionService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/CategoryActivityDefinition?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyCategoryActivityDefinitionModel[]> {

        return this.http.get<e5Models.TaxonomyCategoryActivityDefinitionModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityDefinition` );
    }

    // POST /{scope}/api/Taxonomy/CategoryActivityDefinition?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyCategoryActivityDefinitionModel> {

        return this.http.post<e5Models.TaxonomyCategoryActivityDefinitionModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityDefinition`, postJson );
    }

    // GET /{scope}/api/Taxonomy/CategoryActivityDefinition/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyCategoryActivityDefinitionModel> {

        return this.http.get<e5Models.TaxonomyCategoryActivityDefinitionModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityDefinition/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/CategoryActivityDefinition/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyCategoryActivityDefinitionModel> {

        return this.http.put<e5Models.TaxonomyCategoryActivityDefinitionModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityDefinition/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyCategoryActivityFieldService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/CategoryActivityField?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyCategoryActivityFieldModel[]> {

        return this.http.get<e5Models.TaxonomyCategoryActivityFieldModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityField` );
    }

    // POST /{scope}/api/Taxonomy/CategoryActivityField?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyCategoryActivityFieldModel> {

        return this.http.post<e5Models.TaxonomyCategoryActivityFieldModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityField`, postJson );
    }

    // GET /{scope}/api/Taxonomy/CategoryActivityField/GetByCategoryActivityId/{categoryActivityId}?api-version=1.0
    public getByCategoryActivityId(categoryActivityId: any): Observable<e5Models.TaxonomyCategoryActivityFieldModel> {

        return this.http.get<e5Models.TaxonomyCategoryActivityFieldModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityField/GetByCategoryActivityId/${categoryActivityId}` );
    }

    // GET /{scope}/api/Taxonomy/CategoryActivityField/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyCategoryActivityFieldModel> {

        return this.http.get<e5Models.TaxonomyCategoryActivityFieldModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityField/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/CategoryActivityField/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyCategoryActivityFieldModel> {

        return this.http.put<e5Models.TaxonomyCategoryActivityFieldModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityField/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyCategoryActivityRoleService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/CategoryActivityRole?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyCategoryActivityRoleModel[]> {

        return this.http.get<e5Models.TaxonomyCategoryActivityRoleModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityRole` );
    }

    // POST /{scope}/api/Taxonomy/CategoryActivityRole?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyCategoryActivityRoleModel> {

        return this.http.post<e5Models.TaxonomyCategoryActivityRoleModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityRole`, postJson );
    }

    // GET /{scope}/api/Taxonomy/CategoryActivityRole/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyCategoryActivityRoleModel[]> {

        return this.http.get<e5Models.TaxonomyCategoryActivityRoleModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityRole/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/CategoryActivityRole/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyCategoryActivityRoleModel> {

        return this.http.put<e5Models.TaxonomyCategoryActivityRoleModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryActivityRole/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyCategoryAttachmentTypeService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/CategoryAttachmentType?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyCategoryAttachmentTypeModel[]> {

        return this.http.get<e5Models.TaxonomyCategoryAttachmentTypeModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryAttachmentType` );
    }

    // POST /{scope}/api/Taxonomy/CategoryAttachmentType?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyCategoryAttachmentTypeModel> {

        return this.http.post<e5Models.TaxonomyCategoryAttachmentTypeModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryAttachmentType`, postJson );
    }

    // GET /{scope}/api/Taxonomy/CategoryAttachmentType/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyCategoryAttachmentTypeModel> {

        return this.http.get<e5Models.TaxonomyCategoryAttachmentTypeModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryAttachmentType/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/CategoryAttachmentType/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyCategoryAttachmentTypeModel> {

        return this.http.put<e5Models.TaxonomyCategoryAttachmentTypeModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategoryAttachmentType/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyCategorySiteService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/CategorySite?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyCategorySiteModel[]> {

        return this.http.get<e5Models.TaxonomyCategorySiteModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategorySite` );
    }

    // POST /{scope}/api/Taxonomy/CategorySite?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyCategorySiteModel> {

        return this.http.post<e5Models.TaxonomyCategorySiteModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategorySite`, postJson );
    }

    // GET /{scope}/api/Taxonomy/CategorySite/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyCategorySiteModel[]> {

        return this.http.get<e5Models.TaxonomyCategorySiteModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategorySite/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/CategorySite/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyCategorySiteModel> {

        return this.http.put<e5Models.TaxonomyCategorySiteModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/CategorySite/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyContentTypeCustomService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/ContentType/Custom?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyContentTypeCustomModel[]> {

        return this.http.get<e5Models.TaxonomyContentTypeCustomModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ContentType/Custom` );
    }

    // POST /{scope}/api/Taxonomy/ContentType/Custom?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyContentTypeCustomModel> {

        return this.http.post<e5Models.TaxonomyContentTypeCustomModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ContentType/Custom`, postJson );
    }

    // GET /{scope}/api/Taxonomy/ContentType/Custom/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyContentTypeCustomModel> {

        return this.http.get<e5Models.TaxonomyContentTypeCustomModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ContentType/Custom/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/ContentType/Custom/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyContentTypeCustomModel> {

        return this.http.put<e5Models.TaxonomyContentTypeCustomModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ContentType/Custom/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyContentTypeFieldSetService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/ContentType/FieldSet?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyContentTypeModel[]> {

        return this.http.get<e5Models.TaxonomyContentTypeModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ContentType/FieldSet` );
    }

    // POST /{scope}/api/Taxonomy/ContentType/FieldSet?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyContentTypeFieldSetModel> {

        return this.http.post<e5Models.TaxonomyContentTypeFieldSetModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ContentType/FieldSet`, postJson );
    }

    // GET /{scope}/api/Taxonomy/ContentType/FieldSet/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyContentTypeFieldSetModel> {

        return this.http.get<e5Models.TaxonomyContentTypeFieldSetModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ContentType/FieldSet/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/ContentType/FieldSet/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyContentTypeFieldSetModel> {

        return this.http.put<e5Models.TaxonomyContentTypeFieldSetModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ContentType/FieldSet/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyContentTypeGridService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/ContentType/Grid?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyContentTypeGridModel[]> {

        return this.http.get<e5Models.TaxonomyContentTypeGridModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ContentType/Grid` );
    }

    // POST /{scope}/api/Taxonomy/ContentType/Grid?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyContentTypeGridModel> {

        return this.http.post<e5Models.TaxonomyContentTypeGridModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ContentType/Grid`, postJson );
    }

    // GET /{scope}/api/Taxonomy/ContentType/Grid/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyContentTypeGridModel> {

        return this.http.get<e5Models.TaxonomyContentTypeGridModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ContentType/Grid/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/ContentType/Grid/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyContentTypeGridModel> {

        return this.http.put<e5Models.TaxonomyContentTypeGridModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ContentType/Grid/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyCurrencyService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/Currency?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyCurrencyModel[]> {

        return this.http.get<e5Models.TaxonomyCurrencyModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Currency` );
    }

    // POST /{scope}/api/Taxonomy/Currency?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyCurrencyModel> {

        return this.http.post<e5Models.TaxonomyCurrencyModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Currency`, postJson );
    }

    // GET /{scope}/api/Taxonomy/Currency/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyCurrencyModel> {

        return this.http.get<e5Models.TaxonomyCurrencyModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Currency/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/Currency/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyCurrencyModel> {

        return this.http.put<e5Models.TaxonomyCurrencyModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Currency/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyEventService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/Event?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyEventModel[]> {

        return this.http.get<e5Models.TaxonomyEventModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Event` );
    }

    // POST /{scope}/api/Taxonomy/Event?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyEventModel> {

        return this.http.post<e5Models.TaxonomyEventModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Event`, postJson );
    }

    // GET /{scope}/api/Taxonomy/Event/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyEventModel> {

        return this.http.get<e5Models.TaxonomyEventModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Event/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/Event/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyEventModel> {

        return this.http.put<e5Models.TaxonomyEventModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Event/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyFieldDefinitionService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/FieldDefinition?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyFieldDefinitionModel[]> {

        return this.http.get<e5Models.TaxonomyFieldDefinitionModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition` );
    }

    // GET /{scope}/api/Taxonomy/FieldDefinition/{code}?api-version=1.0
    public get(code: any): Observable<e5Models.TaxonomyFieldDefinitionModel> {

        return this.http.get<e5Models.TaxonomyFieldDefinitionModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/${code}` );
    }

}


@Injectable()
export class TaxonomyFieldDefinitionCaseNoteService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/FieldDefinition/CaseNote?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyFieldDefinitionCaseNoteModel[]> {

        return this.http.get<e5Models.TaxonomyFieldDefinitionCaseNoteModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/CaseNote` );
    }

    // POST /{scope}/api/Taxonomy/FieldDefinition/CaseNote?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyFieldDefinitionCaseNoteModel> {

        return this.http.post<e5Models.TaxonomyFieldDefinitionCaseNoteModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/CaseNote`, postJson );
    }

    // GET /{scope}/api/Taxonomy/FieldDefinition/CaseNote/{code}?api-version=1.0
    public get(code: any): Observable<e5Models.TaxonomyFieldDefinitionCaseNoteModel> {

        return this.http.get<e5Models.TaxonomyFieldDefinitionCaseNoteModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/CaseNote/${code}` );
    }

    // PUT /{scope}/api/Taxonomy/FieldDefinition/CaseNote/{code}?api-version=1.0
    public update(code: any, putJson: any): Observable<e5Models.TaxonomyFieldDefinitionCaseNoteModel> {

        return this.http.put<e5Models.TaxonomyFieldDefinitionCaseNoteModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/CaseNote/${code}`, putJson );
    }

}


@Injectable()
export class TaxonomyFieldDefinitionCurrencyService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/FieldDefinition/Currency?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyFieldDefinitionCurrencyModel[]> {

        return this.http.get<e5Models.TaxonomyFieldDefinitionCurrencyModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Currency` );
    }

    // POST /{scope}/api/Taxonomy/FieldDefinition/Currency?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyFieldDefinitionCurrencyModel> {

        return this.http.post<e5Models.TaxonomyFieldDefinitionCurrencyModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Currency`, postJson );
    }

    // GET /{scope}/api/Taxonomy/FieldDefinition/Currency/{code}?api-version=1.0
    public get(code: any): Observable<e5Models.TaxonomyFieldDefinitionCurrencyModel> {

        return this.http.get<e5Models.TaxonomyFieldDefinitionCurrencyModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Currency/${code}` );
    }

    // PUT /{scope}/api/Taxonomy/FieldDefinition/Currency/{code}?api-version=1.0
    public update(code: any, putJson: any): Observable<e5Models.TaxonomyFieldDefinitionCurrencyModel> {

        return this.http.put<e5Models.TaxonomyFieldDefinitionCurrencyModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Currency/${code}`, putJson );
    }

}


@Injectable()
export class TaxonomyFieldDefinitionLinkService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/FieldDefinition/Link?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyFieldDefinitionLinkModel[]> {

        return this.http.get<e5Models.TaxonomyFieldDefinitionLinkModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Link` );
    }

    // POST /{scope}/api/Taxonomy/FieldDefinition/Link?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyFieldDefinitionLinkModel> {

        return this.http.post<e5Models.TaxonomyFieldDefinitionLinkModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Link`, postJson );
    }

    // GET /{scope}/api/Taxonomy/FieldDefinition/Link/{code}?api-version=1.0
    public get(code: any): Observable<e5Models.TaxonomyFieldDefinitionLinkModel> {

        return this.http.get<e5Models.TaxonomyFieldDefinitionLinkModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Link/${code}` );
    }

    // PUT /{scope}/api/Taxonomy/FieldDefinition/Link/{code}?api-version=1.0
    public update(code: any, putJson: any): Observable<e5Models.TaxonomyFieldDefinitionLinkModel> {

        return this.http.put<e5Models.TaxonomyFieldDefinitionLinkModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Link/${code}`, putJson );
    }

}


@Injectable()
export class TaxonomyFieldDefinitionListService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/FieldDefinition/List?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyFieldDefinitionListModel[]> {

        return this.http.get<e5Models.TaxonomyFieldDefinitionListModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/List` );
    }

    // POST /{scope}/api/Taxonomy/FieldDefinition/List?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyFieldDefinitionListModel> {

        return this.http.post<e5Models.TaxonomyFieldDefinitionListModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/List`, postJson );
    }

    // GET /{scope}/api/Taxonomy/FieldDefinition/List/{code}?api-version=1.0
    public get(code: any): Observable<e5Models.TaxonomyFieldDefinitionListModel> {

        return this.http.get<e5Models.TaxonomyFieldDefinitionListModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/List/${code}` );
    }

    // PUT /{scope}/api/Taxonomy/FieldDefinition/List/{code}?api-version=1.0
    public update(code: any, putJson: any): Observable<e5Models.TaxonomyFieldDefinitionListModel> {

        return this.http.put<e5Models.TaxonomyFieldDefinitionListModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/List/${code}`, putJson );
    }

}


@Injectable()
export class TaxonomyFieldDefinitionLookupService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/FieldDefinition/Lookup?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyFieldDefinitionLookupModel[]> {

        return this.http.get<e5Models.TaxonomyFieldDefinitionLookupModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Lookup` );
    }

    // POST /{scope}/api/Taxonomy/FieldDefinition/Lookup?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyFieldDefinitionLookupModel> {

        return this.http.post<e5Models.TaxonomyFieldDefinitionLookupModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Lookup`, postJson );
    }

    // GET /{scope}/api/Taxonomy/FieldDefinition/Lookup/{code}?api-version=1.0
    public get(code: any): Observable<e5Models.TaxonomyFieldDefinitionLookupModel> {

        return this.http.get<e5Models.TaxonomyFieldDefinitionLookupModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Lookup/${code}` );
    }

    // PUT /{scope}/api/Taxonomy/FieldDefinition/Lookup/{code}?api-version=1.0
    public update(code: any, putJson: any): Observable<e5Models.TaxonomyFieldDefinitionLookupModel> {

        return this.http.put<e5Models.TaxonomyFieldDefinitionLookupModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Lookup/${code}`, putJson );
    }

}


@Injectable()
export class TaxonomyFieldDefinitionSimpleService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/FieldDefinition/Simple?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyFieldDefinitionSimpleModel[]> {

        return this.http.get<e5Models.TaxonomyFieldDefinitionSimpleModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Simple` );
    }

    // POST /{scope}/api/Taxonomy/FieldDefinition/Simple?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyFieldDefinitionSimpleModel> {

        return this.http.post<e5Models.TaxonomyFieldDefinitionSimpleModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Simple`, postJson );
    }

    // GET /{scope}/api/Taxonomy/FieldDefinition/Simple/{code}?api-version=1.0
    public get(code: any): Observable<e5Models.TaxonomyFieldDefinitionSimpleModel> {

        return this.http.get<e5Models.TaxonomyFieldDefinitionSimpleModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Simple/${code}` );
    }

    // PUT /{scope}/api/Taxonomy/FieldDefinition/Simple/{code}?api-version=1.0
    public update(code: any, putJson: any): Observable<e5Models.TaxonomyFieldDefinitionSimpleModel> {

        return this.http.put<e5Models.TaxonomyFieldDefinitionSimpleModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/FieldDefinition/Simple/${code}`, putJson );
    }

}


@Injectable()
export class TaxonomyFieldFoundationService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/Field/GetFilteredList/{listId}?filterText={filterText}&maxRecordsToSuggest={maxRecordsToSuggest}&parentListId={parentListId}&parentListItemId={parentListItemId}&api-version=1.0
    public getFilteredList(listId: any, options?: { filterText ?: any, maxRecordsToSuggest ?: any, parentListId ?: any, parentListItemId ?: any}): Observable<e5Models.FoundationTaxonomyFilteredListFModel> {
        let params = new HttpParams();
        if (options && typeof(options.filterText) !== 'undefined') { params = params.append('filterText', options.filterText); }
        if (options && typeof(options.maxRecordsToSuggest) !== 'undefined') { params = params.append('maxRecordsToSuggest', options.maxRecordsToSuggest); }
        if (options && typeof(options.parentListId) !== 'undefined') { params = params.append('parentListId', options.parentListId); }
        if (options && typeof(options.parentListItemId) !== 'undefined') { params = params.append('parentListItemId', options.parentListItemId); }

        return this.http.get<e5Models.FoundationTaxonomyFilteredListFModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Field/GetFilteredList/${listId}` , { params: params });
    }

    // GET /{scope}/api/Taxonomy/Field/GetList/{listId}?parentListId={parentListId}&parentListItemId={parentListItemId}&api-version=1.0
    public getList(listId: any, options?: { parentListId ?: any, parentListItemId ?: any}): Observable<e5Models.FoundationTaxonomyListFModel> {
        let params = new HttpParams();
        if (options && typeof(options.parentListId) !== 'undefined') { params = params.append('parentListId', options.parentListId); }
        if (options && typeof(options.parentListItemId) !== 'undefined') { params = params.append('parentListItemId', options.parentListItemId); }

        return this.http.get<e5Models.FoundationTaxonomyListFModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Field/GetList/${listId}` , { params: params });
    }

}


@Injectable()
export class TaxonomyLibraryService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/Library?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyLibraryModel[]> {

        return this.http.get<e5Models.TaxonomyLibraryModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Library` );
    }

    // POST /{scope}/api/Taxonomy/Library?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyLibraryModel> {

        return this.http.post<e5Models.TaxonomyLibraryModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Library`, postJson );
    }

    // GET /{scope}/api/Taxonomy/Library/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyLibraryModel> {

        return this.http.get<e5Models.TaxonomyLibraryModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Library/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/Library/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyLibraryModel> {

        return this.http.put<e5Models.TaxonomyLibraryModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Library/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyListService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/List?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyListModel[]> {

        return this.http.get<e5Models.TaxonomyListModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/List` );
    }

    // POST /{scope}/api/Taxonomy/List?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyListModel> {

        return this.http.post<e5Models.TaxonomyListModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/List`, postJson );
    }

    // GET /{scope}/api/Taxonomy/List/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyListModel> {

        return this.http.get<e5Models.TaxonomyListModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/List/${id}` );
    }

    // POST /{scope}/api/Taxonomy/List/{id}?api-version=1.0
    public createWithId(id: any, postJson: any): Observable<e5Models.TaxonomyListModel> {

        return this.http.post<e5Models.TaxonomyListModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/List/${id}`, postJson );
    }

    // PUT /{scope}/api/Taxonomy/List/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyListModel> {

        return this.http.put<e5Models.TaxonomyListModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/List/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyListItemService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/ListItem?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyListItemModel[]> {

        return this.http.get<e5Models.TaxonomyListItemModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ListItem` );
    }

    // POST /{scope}/api/Taxonomy/ListItem?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyListItemModel> {

        return this.http.post<e5Models.TaxonomyListItemModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ListItem`, postJson );
    }

    // GET /{scope}/api/Taxonomy/ListItem/GetByListId/{id}?api-version=1.0
    public getByListId(id: any): Observable<e5Models.TaxonomyListItemModel[]> {

        return this.http.get<e5Models.TaxonomyListItemModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ListItem/GetByListId/${id}` );
    }

    // GET /{scope}/api/Taxonomy/ListItem/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyListItemModel> {

        return this.http.get<e5Models.TaxonomyListItemModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ListItem/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/ListItem/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyListItemModel> {

        return this.http.put<e5Models.TaxonomyListItemModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/ListItem/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyLocationService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/Location?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyLocationModel[]> {

        return this.http.get<e5Models.TaxonomyLocationModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Location` );
    }

    // POST /{scope}/api/Taxonomy/Location?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyLocationModel> {

        return this.http.post<e5Models.TaxonomyLocationModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Location`, postJson );
    }

    // GET /{scope}/api/Taxonomy/Location/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyLocationModel> {

        return this.http.get<e5Models.TaxonomyLocationModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Location/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/Location/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyLocationModel> {

        return this.http.put<e5Models.TaxonomyLocationModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Location/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyLookupService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/Lookup?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyLookupModel[]> {

        return this.http.get<e5Models.TaxonomyLookupModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Lookup` );
    }

    // POST /{scope}/api/Taxonomy/Lookup?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyLookupModel> {

        return this.http.post<e5Models.TaxonomyLookupModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Lookup`, postJson );
    }

    // GET /{scope}/api/Taxonomy/Lookup/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyLookupModel> {

        return this.http.get<e5Models.TaxonomyLookupModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Lookup/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/Lookup/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyLookupModel> {

        return this.http.put<e5Models.TaxonomyLookupModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Lookup/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyMenuService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/Menu?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyMenuModel[]> {

        return this.http.get<e5Models.TaxonomyMenuModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Menu` );
    }

    // POST /{scope}/api/Taxonomy/Menu?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyMenuModel> {

        return this.http.post<e5Models.TaxonomyMenuModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Menu`, postJson );
    }

    // GET /{scope}/api/Taxonomy/Menu/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyMenuModel> {

        return this.http.get<e5Models.TaxonomyMenuModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Menu/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/Menu/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyMenuModel> {

        return this.http.put<e5Models.TaxonomyMenuModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Menu/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyMenuItemDefinitionService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/MenuItemDefinition?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyMenuItemDefinitionModel[]> {

        return this.http.get<e5Models.TaxonomyMenuItemDefinitionModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/MenuItemDefinition` );
    }

    // POST /{scope}/api/Taxonomy/MenuItemDefinition?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyMenuItemDefinitionModel> {

        return this.http.post<e5Models.TaxonomyMenuItemDefinitionModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/MenuItemDefinition`, postJson );
    }

    // GET /{scope}/api/Taxonomy/MenuItemDefinition/GetByMenuId/{menuId}?api-version=1.0
    public getByMenuId(menuId: any): Observable<e5Models.TaxonomyMenuItemDefinitionModel[]> {

        return this.http.get<e5Models.TaxonomyMenuItemDefinitionModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/MenuItemDefinition/GetByMenuId/${menuId}` );
    }

    // GET /{scope}/api/Taxonomy/MenuItemDefinition/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyMenuItemDefinitionModel> {

        return this.http.get<e5Models.TaxonomyMenuItemDefinitionModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/MenuItemDefinition/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/MenuItemDefinition/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyMenuItemDefinitionModel> {

        return this.http.put<e5Models.TaxonomyMenuItemDefinitionModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/MenuItemDefinition/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyPriorityService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/Priority?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyPriorityModel[]> {

        return this.http.get<e5Models.TaxonomyPriorityModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Priority` );
    }

    // POST /{scope}/api/Taxonomy/Priority?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyPriorityModel> {

        return this.http.post<e5Models.TaxonomyPriorityModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Priority`, postJson );
    }

    // GET /{scope}/api/Taxonomy/Priority/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyPriorityModel[]> {

        return this.http.get<e5Models.TaxonomyPriorityModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Priority/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/Priority/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyPriorityModel> {

        return this.http.put<e5Models.TaxonomyPriorityModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Priority/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyPublicHolidayService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/PublicHoliday?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyPublicHolidayModel[]> {

        return this.http.get<e5Models.TaxonomyPublicHolidayModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/PublicHoliday` );
    }

    // POST /{scope}/api/Taxonomy/PublicHoliday?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyPublicHolidayModel> {

        return this.http.post<e5Models.TaxonomyPublicHolidayModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/PublicHoliday`, postJson );
    }

    // GET /{scope}/api/Taxonomy/PublicHoliday/GetByLocationId/{Id}?api-version=1.0
    public getByLocationId(Id: any): Observable<e5Models.TaxonomyPublicHolidayModel[]> {

        return this.http.get<e5Models.TaxonomyPublicHolidayModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/PublicHoliday/GetByLocationId/${Id}` );
    }

    // GET /{scope}/api/Taxonomy/PublicHoliday/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyPublicHolidayModel> {

        return this.http.get<e5Models.TaxonomyPublicHolidayModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/PublicHoliday/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/PublicHoliday/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyPublicHolidayModel> {

        return this.http.put<e5Models.TaxonomyPublicHolidayModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/PublicHoliday/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyRoleService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/Role?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyRoleModel[]> {

        return this.http.get<e5Models.TaxonomyRoleModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Role` );
    }

    // POST /{scope}/api/Taxonomy/Role?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyRoleModel> {

        return this.http.post<e5Models.TaxonomyRoleModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Role`, postJson );
    }

    // GET /{scope}/api/Taxonomy/Role/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyRoleModel> {

        return this.http.get<e5Models.TaxonomyRoleModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Role/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/Role/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyRoleModel> {

        return this.http.put<e5Models.TaxonomyRoleModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Role/${id}`, putJson );
    }

}


@Injectable()
export class TaxonomyStatusService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Taxonomy/Status?api-version=1.0
    public getAll(): Observable<e5Models.TaxonomyStatusModel[]> {

        return this.http.get<e5Models.TaxonomyStatusModel[]>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Status` );
    }

    // POST /{scope}/api/Taxonomy/Status?api-version=1.0
    public create(postJson: any): Observable<e5Models.TaxonomyStatusModel> {

        return this.http.post<e5Models.TaxonomyStatusModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Status`, postJson );
    }

    // GET /{scope}/api/Taxonomy/Status/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.TaxonomyStatusModel> {

        return this.http.get<e5Models.TaxonomyStatusModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Status/${id}` );
    }

    // PUT /{scope}/api/Taxonomy/Status/{id}?api-version=1.0
    public update(id: any, putJson: any): Observable<e5Models.TaxonomyStatusModel> {

        return this.http.put<e5Models.TaxonomyStatusModel>(`${this.baseUrl}/${this.scope}/api/Taxonomy/Status/${id}`, putJson );
    }

}


@Injectable()
export class UiAttachmentService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/ui/Attachment/Download/{workId}/{attachmentId}?api-version=1.0
    public get(workId: any, attachmentId: any): Observable<any> {

        return this.http.get<any>(`${this.baseUrl}/${this.scope}/api/ui/Attachment/Download/${workId}/${attachmentId}` );
    }

}


@Injectable()
export class UiDocumentService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/ui/Document/GetDocuments/{libraryId}?returnFields={returnFields}&folderName={folderName}&orderBy={orderBy}&searchBy={searchBy}&filter={filter}&page={page}&pageSize={pageSize}&api-version=1.0
    public getAll(libraryId: any, options?: { returnFields ?: any, folderName ?: any, orderBy ?: any, searchBy ?: any, filter ?: any, page ?: any, pageSize ?: any}): Observable<e5Models.UIDocumentsModel[]> {
        let params = new HttpParams();
        if (options && typeof(options.returnFields) !== 'undefined') { params = params.append('returnFields', options.returnFields); }
        if (options && typeof(options.folderName) !== 'undefined') { params = params.append('folderName', options.folderName); }
        if (options && typeof(options.orderBy) !== 'undefined') { params = params.append('orderBy', options.orderBy); }
        if (options && typeof(options.searchBy) !== 'undefined') { params = params.append('searchBy', options.searchBy); }
        if (options && typeof(options.filter) !== 'undefined') { params = params.append('filter', options.filter); }
        if (options && typeof(options.page) !== 'undefined') { params = params.append('page', options.page); }
        if (options && typeof(options.pageSize) !== 'undefined') { params = params.append('pageSize', options.pageSize); }

        return this.http.get<e5Models.UIDocumentsModel[]>(`${this.baseUrl}/${this.scope}/api/ui/Document/GetDocuments/${libraryId}` , { params: params });
    }

}


@Injectable()
export class UiSearchDefinitionService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/ui/SearchDefinition?api-version=1.0
    public getAll(): Observable<e5Models.UISearchDefinitionRefModel> {

        return this.http.get<e5Models.UISearchDefinitionRefModel>(`${this.baseUrl}/${this.scope}/api/ui/SearchDefinition` );
    }

    // GET /{scope}/api/ui/SearchDefinition/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.UISearchDefinitionModel> {

        return this.http.get<e5Models.UISearchDefinitionModel>(`${this.baseUrl}/${this.scope}/api/ui/SearchDefinition/${id}` );
    }

}


@Injectable()
export class UiWorkItemService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/ui/WorkItem/{id}?api-version=1.0
    public getAll(id: any): Observable<e5Models.UIWorkItemModel> {

        return this.http.get<e5Models.UIWorkItemModel>(`${this.baseUrl}/${this.scope}/api/ui/WorkItem/${id}` );
    }

    // GET /{scope}/api/ui/WorkItem/{id}/FieldSet?api-version=1.0
    public fieldSet(id: any): Observable<e5Models.UIMenuModel[]> {

        return this.http.get<e5Models.UIMenuModel[]>(`${this.baseUrl}/${this.scope}/api/ui/WorkItem/${id}/FieldSet` );
    }

    // GET /{scope}/api/ui/WorkItem/{id}/Menu?api-version=1.0
    public menu(id: any): Observable<e5Models.UIMenuModel[]> {

        return this.http.get<e5Models.UIMenuModel[]>(`${this.baseUrl}/${this.scope}/api/ui/WorkItem/${id}/Menu` );
    }

    // GET /{scope}/api/ui/WorkItem/{id}/Property?api-version=1.0
    public property(id: any): Observable<e5Models.UIMenuModel[]> {

        return this.http.get<e5Models.UIMenuModel[]>(`${this.baseUrl}/${this.scope}/api/ui/WorkItem/${id}/Property` );
    }

    // GET /{scope}/api/ui/WorkItem/{id}/Tab?api-version=1.0
    public tab(id: any): Observable<e5Models.UIMenuModel[]> {

        return this.http.get<e5Models.UIMenuModel[]>(`${this.baseUrl}/${this.scope}/api/ui/WorkItem/${id}/Tab` );
    }

}


@Injectable()
export class WorkAttachmentFoundationService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // POST /{scope}/api/Attachment/Add/{workId}?ContentDisposition={ContentDisposition}&attachmentTypeId={attachmentTypeId}&ContentType={ContentType}&Headers={Headers}&Length={Length}&Name={Name}&FileName={FileName}&api-version=1.0
    public add(workId: any, options?: { ContentDisposition ?: any, attachmentTypeId ?: any, ContentType ?: any, Headers ?: any, Length ?: any, Name ?: any, FileName ?: any}): Observable<Object> {
        let params = new HttpParams();
        if (options && typeof(options.ContentDisposition) !== 'undefined') { params = params.append('ContentDisposition', options.ContentDisposition); }
        if (options && typeof(options.attachmentTypeId) !== 'undefined') { params = params.append('attachmentTypeId', options.attachmentTypeId); }
        if (options && typeof(options.ContentType) !== 'undefined') { params = params.append('ContentType', options.ContentType); }
        if (options && typeof(options.Headers) !== 'undefined') { params = params.append('Headers', options.Headers); }
        if (options && typeof(options.Length) !== 'undefined') { params = params.append('Length', options.Length); }
        if (options && typeof(options.Name) !== 'undefined') { params = params.append('Name', options.Name); }
        if (options && typeof(options.FileName) !== 'undefined') { params = params.append('FileName', options.FileName); }

        return this.http.post<Object>(`${this.baseUrl}/${this.scope}/api/Attachment/Add/${workId}`, null , { params: params });
    }

    // POST /{scope}/api/Attachment/AddBase64/{workId}?attachmentTypeId={attachmentTypeId}&api-version=1.0
    public addBase64(workId: any, postJson: any, options?: { attachmentTypeId ?: any}): Observable<Object> {
        let params = new HttpParams();
        if (options && typeof(options.attachmentTypeId) !== 'undefined') { params = params.append('attachmentTypeId', options.attachmentTypeId); }

        return this.http.post<Object>(`${this.baseUrl}/${this.scope}/api/Attachment/AddBase64/${workId}`, postJson , { params: params });
    }

    // PUT /{scope}/api/Attachment/Attach/{workId}/{attachmentId}?api-version=1.0
    public attach(workId: any, attachmentId: any): Observable<Object> {

        return this.http.put<Object>(`${this.baseUrl}/${this.scope}/api/Attachment/Attach/${workId}/${attachmentId}`, null );
    }

    // PUT /{scope}/api/Attachment/ChangeType/{workId}/{attachmentId}/{targetAttachmentType}?api-version=1.0
    public changeType(workId: any, attachmentId: any, targetAttachmentType: any): Observable<e5Models.FoundationWorkAttachmentFModel> {

        return this.http.put<e5Models.FoundationWorkAttachmentFModel>(`${this.baseUrl}/${this.scope}/api/Attachment/ChangeType/${workId}/${attachmentId}/${targetAttachmentType}`, null );
    }

    // PUT /{scope}/api/Attachment/Convert/{workId}/{attachmentId}/{targetFormat}?api-version=1.0
    public convert(workId: any, attachmentId: any, targetFormat: any): Observable<e5Models.FoundationWorkAttachmentFModel> {

        return this.http.put<e5Models.FoundationWorkAttachmentFModel>(`${this.baseUrl}/${this.scope}/api/Attachment/Convert/${workId}/${attachmentId}/${targetFormat}`, null );
    }

    // PUT /{scope}/api/Attachment/Detach/{workId}/{attachmentId}?api-version=1.0
    public detach(workId: any, attachmentId: any): Observable<Object> {

        return this.http.put<Object>(`${this.baseUrl}/${this.scope}/api/Attachment/Detach/${workId}/${attachmentId}`, null );
    }

    // PUT /{scope}/api/Attachment/Email/{workId}/{attachmentId}?api-version=1.0
    public email(workId: any, attachmentId: any, putJson: any): Observable<Object> {

        return this.http.put<Object>(`${this.baseUrl}/${this.scope}/api/Attachment/Email/${workId}/${attachmentId}`, putJson );
    }

    // GET /{scope}/api/Attachment/GetAbsoluteUrl/{workId}/{attachmentId}?api-version=1.0
    public getAbsoluteUrl(workId: any, attachmentId: any): Observable<Object> {

        return this.http.get<Object>(`${this.baseUrl}/${this.scope}/api/Attachment/GetAbsoluteUrl/${workId}/${attachmentId}` );
    }

    // GET /{scope}/api/Attachment/GetBinary/{workId}/{attachmentId}?api-version=1.0
    public getBinary(workId: any, attachmentId: any): Observable<Object> {

        return this.http.get<Object>(`${this.baseUrl}/${this.scope}/api/Attachment/GetBinary/${workId}/${attachmentId}` );
    }

    // GET /{scope}/api/Attachment/GetConvertTargets/{attachmentId}?api-version=1.0
    public getConvertTargets(attachmentId: any): Observable<Object> {

        return this.http.get<Object>(`${this.baseUrl}/${this.scope}/api/Attachment/GetConvertTargets/${attachmentId}` );
    }

    // PUT /{scope}/api/Attachment/Split/{workId}/{attachmentId}?api-version=1.0
    public split(workId: any, attachmentId: any, putJson: any): Observable<e5Models.FoundationWorkAttachmentFModel> {

        return this.http.put<e5Models.FoundationWorkAttachmentFModel>(`${this.baseUrl}/${this.scope}/api/Attachment/Split/${workId}/${attachmentId}`, putJson );
    }

    // PUT /{scope}/api/Attachment/TearOff/{workId}/{attachmentId}?api-version=1.0
    public tearOff(workId: any, attachmentId: any, putJson: any): Observable<e5Models.FoundationWorkAttachmentFModel> {

        return this.http.put<e5Models.FoundationWorkAttachmentFModel>(`${this.baseUrl}/${this.scope}/api/Attachment/TearOff/${workId}/${attachmentId}`, putJson );
    }

    // GET /{scope}/api/Attachment/{workId}?attachmentId={attachmentId}&attachmentTypeId={attachmentTypeId}&api-version=1.0
    public get(workId: any, options?: { attachmentId ?: any, attachmentTypeId ?: any}): Observable<e5Models.FoundationWorkAttachmentFModel> {
        let params = new HttpParams();
        if (options && typeof(options.attachmentId) !== 'undefined') { params = params.append('attachmentId', options.attachmentId); }
        if (options && typeof(options.attachmentTypeId) !== 'undefined') { params = params.append('attachmentTypeId', options.attachmentTypeId); }

        return this.http.get<e5Models.FoundationWorkAttachmentFModel>(`${this.baseUrl}/${this.scope}/api/Attachment/${workId}` , { params: params });
    }

}


@Injectable()
export class WorkAttachmentTypeFoundationService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/AttachmentType/{workId}?api-version=1.0
    public get(workId: any): Observable<e5Models.TaxonomyAttachmentTypeModel[]> {

        return this.http.get<e5Models.TaxonomyAttachmentTypeModel[]>(`${this.baseUrl}/${this.scope}/api/AttachmentType/${workId}` );
    }

}


@Injectable()
export class WorkCaseNoteFoundationService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // POST /{scope}/api/CaseNote/Add/{workId}/{caseNoteField}?api-version=1.0
    public add(workId: any, caseNoteField: any, postJson: any): Observable<e5Models.FoundationWorkItemFModel> {

        return this.http.post<e5Models.FoundationWorkItemFModel>(`${this.baseUrl}/${this.scope}/api/CaseNote/Add/${workId}/${caseNoteField}`, postJson );
    }

    // GET /{scope}/api/CaseNote/Export/{workId}?format={format}&includeRelated={includeRelated}&api-version=1.0
    public exportCaseNote(workId: any, options?: { format ?: any, includeRelated ?: any}): Observable<Object> {
        let params = new HttpParams();
        if (options && typeof(options.format) !== 'undefined') { params = params.append('format', options.format); }
        if (options && typeof(options.includeRelated) !== 'undefined') { params = params.append('includeRelated', options.includeRelated); }

        return this.http.get<Object>(`${this.baseUrl}/${this.scope}/api/CaseNote/Export/${workId}` , { params: params });
    }

    // POST /{scope}/api/CaseNote/{workId}?includeRelated={includeRelated}&typeId={typeId}&page={page}&pageSize={pageSize}&orderBy={orderBy}&api-version=1.0
    public createWithId(workId: any, postJson: any, options?: { includeRelated ?: any, typeId ?: any, page ?: any, pageSize ?: any, orderBy ?: any}): Observable<e5Models.FoundationWorkCaseNoteResultModel> {
        let params = new HttpParams();
        if (options && typeof(options.includeRelated) !== 'undefined') { params = params.append('includeRelated', options.includeRelated); }
        if (options && typeof(options.typeId) !== 'undefined') { params = params.append('typeId', options.typeId); }
        if (options && typeof(options.page) !== 'undefined') { params = params.append('page', options.page); }
        if (options && typeof(options.pageSize) !== 'undefined') { params = params.append('pageSize', options.pageSize); }
        if (options && typeof(options.orderBy) !== 'undefined') { params = params.append('orderBy', options.orderBy); }

        return this.http.post<e5Models.FoundationWorkCaseNoteResultModel>(`${this.baseUrl}/${this.scope}/api/CaseNote/${workId}`, postJson , { params: params });
    }

}


@Injectable()
export class WorkConversationFoundationService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Conversation/GetTotalEmailCount/{workId}?api-version=1.0
    public getTotalEmailCount(workId: any): Observable<Object> {

        return this.http.get<Object>(`${this.baseUrl}/${this.scope}/api/Conversation/GetTotalEmailCount/${workId}` );
    }

    // GET /{scope}/api/Conversation/GetUniqueEmailAsMhtml/{workId}/{workAttachmentId}?api-version=1.0
    public getUniqueEmailAsMhtml(workId: any, workAttachmentId: any): Observable<Object> {

        return this.http.get<Object>(`${this.baseUrl}/${this.scope}/api/Conversation/GetUniqueEmailAsMhtml/${workId}/${workAttachmentId}` );
    }

    // POST /{scope}/api/Conversation/SendEmail/{workId}?api-version=1.0
    public sendEmail(workId: any, postJson: any): Observable<Object> {

        return this.http.post<Object>(`${this.baseUrl}/${this.scope}/api/Conversation/SendEmail/${workId}`, postJson );
    }

    // GET /{scope}/api/Conversation/{workId}?api-version=1.0
    public get(workId: any): Observable<e5Models.FoundationWorkConversationGroupFModel> {

        return this.http.get<e5Models.FoundationWorkConversationGroupFModel>(`${this.baseUrl}/${this.scope}/api/Conversation/${workId}` );
    }

}


@Injectable()
export class WorkDocumentFoundationService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Document/Create/{workId}/{templateId}/{attachmentTypeId}?documentName={documentName}&api-version=1.0
    public create(workId: any, templateId: any, attachmentTypeId: any, options?: { documentName ?: any}): Observable<e5Models.FoundationWorkDocumentReferenceFModel> {
        let params = new HttpParams();
        if (options && typeof(options.documentName) !== 'undefined') { params = params.append('documentName', options.documentName); }

        return this.http.get<e5Models.FoundationWorkDocumentReferenceFModel>(`${this.baseUrl}/${this.scope}/api/Document/Create/${workId}/${templateId}/${attachmentTypeId}` , { params: params });
    }

    // GET /{scope}/api/Document/GetDocumentTemplates/{workId}?filter={filter}&api-version=1.0
    public getDocumentTemplates(workId: any, options?: { filter ?: any}): Observable<e5Models.TaxonomyDocumentTemplateModel[]> {
        let params = new HttpParams();
        if (options && typeof(options.filter) !== 'undefined') { params = params.append('filter', options.filter); }

        return this.http.get<e5Models.TaxonomyDocumentTemplateModel[]>(`${this.baseUrl}/${this.scope}/api/Document/GetDocumentTemplates/${workId}` , { params: params });
    }

}


@Injectable()
export class WorkFieldFoundationService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Field/{workId}?taskId={taskId}&tabId={tabId}&fieldSetId={fieldSetId}&fieldId={fieldId}&select={select}&api-version=1.0
    public get(workId: any, options?: { taskId ?: any, tabId ?: any, fieldSetId ?: any, fieldId ?: any, select ?: any}): Observable<e5Models.FoundationTaxonomyFieldFModel[]> {
        let params = new HttpParams();
        if (options && typeof(options.taskId) !== 'undefined') { params = params.append('taskId', options.taskId); }
        if (options && typeof(options.tabId) !== 'undefined') { params = params.append('tabId', options.tabId); }
        if (options && typeof(options.fieldSetId) !== 'undefined') { params = params.append('fieldSetId', options.fieldSetId); }
        if (options && typeof(options.fieldId) !== 'undefined') { params = params.append('fieldId', options.fieldId); }
        if (options && typeof(options.select) !== 'undefined') { params = params.append('select', options.select); }

        return this.http.get<e5Models.FoundationTaxonomyFieldFModel[]>(`${this.baseUrl}/${this.scope}/api/Field/${workId}` , { params: params });
    }

}


@Injectable()
export class WorkFieldSetFoundationService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // PUT /{scope}/api/FieldSet/Save/{workId}/{fieldSetId}/{rowId}?taskId={taskId}&api-version=1.0
    public save(workId: any, fieldSetId: any, rowId: any, putJson: any, options?: { taskId ?: any}): Observable<e5Models.FoundationTaxonomyFieldSetFModel> {
        let params = new HttpParams();
        if (options && typeof(options.taskId) !== 'undefined') { params = params.append('taskId', options.taskId); }

        return this.http.put<e5Models.FoundationTaxonomyFieldSetFModel>(`${this.baseUrl}/${this.scope}/api/FieldSet/Save/${workId}/${fieldSetId}/${rowId}`, putJson , { params: params });
    }

    // GET /{scope}/api/FieldSet/{workId}?rowId={rowId}&taskId={taskId}&fieldSetId={fieldSetId}&select={select}&orderBy={orderBy}&page={page}&pageSize={pageSize}&api-version=1.0
    public get(workId: any, options?: { rowId ?: any, taskId ?: any, fieldSetId ?: any, select ?: any, orderBy ?: any, page ?: any, pageSize ?: any}): Observable<e5Models.FoundationTaxonomyFieldSetFModel[]> {
        let params = new HttpParams();
        if (options && typeof(options.rowId) !== 'undefined') { params = params.append('rowId', options.rowId); }
        if (options && typeof(options.taskId) !== 'undefined') { params = params.append('taskId', options.taskId); }
        if (options && typeof(options.fieldSetId) !== 'undefined') { params = params.append('fieldSetId', options.fieldSetId); }
        if (options && typeof(options.select) !== 'undefined') { params = params.append('select', options.select); }
        if (options && typeof(options.orderBy) !== 'undefined') { params = params.append('orderBy', options.orderBy); }
        if (options && typeof(options.page) !== 'undefined') { params = params.append('page', options.page); }
        if (options && typeof(options.pageSize) !== 'undefined') { params = params.append('pageSize', options.pageSize); }

        return this.http.get<e5Models.FoundationTaxonomyFieldSetFModel[]>(`${this.baseUrl}/${this.scope}/api/FieldSet/${workId}` , { params: params });
    }

}


@Injectable()
export class WorkGetNextService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/Work/WorkGetNext/CalculateGetNextValue/{id}?returnWorkItem={returnWorkItem}&update={update}&api-version=1.0
    public calculateGetNextValue(id: any, options?: { returnWorkItem ?: any, update ?: any}): Observable<e5Models.WorkGetNextValueResponse> {
        let params = new HttpParams();
        if (options && typeof(options.returnWorkItem) !== 'undefined') { params = params.append('returnWorkItem', options.returnWorkItem); }
        if (options && typeof(options.update) !== 'undefined') { params = params.append('update', options.update); }

        return this.http.get<e5Models.WorkGetNextValueResponse>(`${this.baseUrl}/${this.scope}/api/Work/WorkGetNext/CalculateGetNextValue/${id}` , { params: params });
    }

    // GET /{scope}/api/Work/WorkGetNext/GetNextId?lockWorkItem={lockWorkItem}&api-version=1.0
    public getNextId( options?: { lockWorkItem ?: any}): Observable<e5Models.WorkGetNextIdResponse> {
        let params = new HttpParams();
        if (options && typeof(options.lockWorkItem) !== 'undefined') { params = params.append('lockWorkItem', options.lockWorkItem); }

        return this.http.get<e5Models.WorkGetNextIdResponse>(`${this.baseUrl}/${this.scope}/api/Work/WorkGetNext/GetNextId` , { params: params });
    }

    // GET /{scope}/api/Work/WorkGetNext/GetNextWorkItem?lockWorkItem={lockWorkItem}&api-version=1.0
    public getNextWorkItem( options?: { lockWorkItem ?: any}): Observable<e5Models.WorkGetNextResponse> {
        let params = new HttpParams();
        if (options && typeof(options.lockWorkItem) !== 'undefined') { params = params.append('lockWorkItem', options.lockWorkItem); }

        return this.http.get<e5Models.WorkGetNextResponse>(`${this.baseUrl}/${this.scope}/api/Work/WorkGetNext/GetNextWorkItem` , { params: params });
    }

}


@Injectable()
export class WorkItemService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // POST /{scope}/api/Work/WorkItem?api-version=1.0
    public create(postJson: any): Observable<e5Models.WorkItemModel> {

        return this.http.post<e5Models.WorkItemModel>(`${this.baseUrl}/${this.scope}/api/Work/WorkItem`, postJson );
    }

    // PUT /{scope}/api/Work/WorkItem/AddCaseNote/{id}?autoLock={autoLock}&api-version=1.0
    public addCaseNote(id: any, putJson: any, options?: { autoLock ?: any}): Observable<Object> {
        let params = new HttpParams();
        if (options && typeof(options.autoLock) !== 'undefined') { params = params.append('autoLock', options.autoLock); }

        return this.http.put<Object>(`${this.baseUrl}/${this.scope}/api/Work/WorkItem/AddCaseNote/${id}`, putJson , { params: params });
    }

    // PUT /{scope}/api/Work/WorkItem/AddEvent/{id}?autoLock={autoLock}&api-version=1.0
    public addEvent(id: any, putJson: any, options?: { autoLock ?: any}): Observable<Object> {
        let params = new HttpParams();
        if (options && typeof(options.autoLock) !== 'undefined') { params = params.append('autoLock', options.autoLock); }

        return this.http.put<Object>(`${this.baseUrl}/${this.scope}/api/Work/WorkItem/AddEvent/${id}`, putJson , { params: params });
    }

    // GET /{scope}/api/Work/WorkItem/GetAssignableUsers/{workId}?api-version=1.0
    public getAssignableUsers(workId: any): Observable<e5Models.UserModel[]> {

        return this.http.get<e5Models.UserModel[]>(`${this.baseUrl}/${this.scope}/api/Work/WorkItem/GetAssignableUsers/${workId}` );
    }

    // GET /{scope}/api/Work/WorkItem/GetByReference/{id}?api-version=1.0
    public getByReference(id: any): Observable<e5Models.WorkItemModel> {

        return this.http.get<e5Models.WorkItemModel>(`${this.baseUrl}/${this.scope}/api/Work/WorkItem/GetByReference/${id}` );
    }

    // GET /{scope}/api/Work/WorkItem/GetWorkRelatedItems/{workId}?findId={findId}&pageSize={pageSize}&pageNo={pageNo}&doSearchFromRoot={doSearchFromRoot}&api-version=1.0
    public getWorkRelatedItems(workId: any, options?: { findId ?: any, pageSize ?: any, pageNo ?: any, doSearchFromRoot ?: any}): Observable<e5Models.WorkRelatedItemsModel> {
        let params = new HttpParams();
        if (options && typeof(options.findId) !== 'undefined') { params = params.append('findId', options.findId); }
        if (options && typeof(options.pageSize) !== 'undefined') { params = params.append('pageSize', options.pageSize); }
        if (options && typeof(options.pageNo) !== 'undefined') { params = params.append('pageNo', options.pageNo); }
        if (options && typeof(options.doSearchFromRoot) !== 'undefined') { params = params.append('doSearchFromRoot', options.doSearchFromRoot); }

        return this.http.get<e5Models.WorkRelatedItemsModel>(`${this.baseUrl}/${this.scope}/api/Work/WorkItem/GetWorkRelatedItems/${workId}` , { params: params });
    }

    // GET /{scope}/api/Work/WorkItem/GetWorkWorkClassChildren/{workId}?api-version=1.0
    public getWorkWorkClassChildren(workId: any): Observable<e5Models.WorkClassChildrenModel[]> {

        return this.http.get<e5Models.WorkClassChildrenModel[]>(`${this.baseUrl}/${this.scope}/api/Work/WorkItem/GetWorkWorkClassChildren/${workId}` );
    }

    // PUT /{scope}/api/Work/WorkItem/IsLocked/{id}?returnWorkItem={returnWorkItem}&api-version=1.0
    public isLocked(id: any, options?: { returnWorkItem ?: any}): Observable<e5Models.WorkIsLockedWorkItemResponse> {
        let params = new HttpParams();
        if (options && typeof(options.returnWorkItem) !== 'undefined') { params = params.append('returnWorkItem', options.returnWorkItem); }

        return this.http.put<e5Models.WorkIsLockedWorkItemResponse>(`${this.baseUrl}/${this.scope}/api/Work/WorkItem/IsLocked/${id}`, null , { params: params });
    }

    // PUT /{scope}/api/Work/WorkItem/Lock/{id}?lockMode={lockMode}&returnWorkItem={returnWorkItem}&api-version=1.0
    public lock(id: any, options?: { lockMode ?: any, returnWorkItem ?: any}): Observable<e5Models.WorkLockWorkItemResponse> {
        let params = new HttpParams();
        if (options && typeof(options.lockMode) !== 'undefined') { params = params.append('lockMode', options.lockMode); }
        if (options && typeof(options.returnWorkItem) !== 'undefined') { params = params.append('returnWorkItem', options.returnWorkItem); }

        return this.http.put<e5Models.WorkLockWorkItemResponse>(`${this.baseUrl}/${this.scope}/api/Work/WorkItem/Lock/${id}`, null , { params: params });
    }

    // PUT /{scope}/api/Work/WorkItem/Reclassify/{id}/{category1Id}/{category2Id}/{category3Id}?autoLock={autoLock}&api-version=1.0
    public reclassify(id: any, category1Id: any, category2Id: any, category3Id: any, options?: { autoLock ?: any}): Observable<Object> {
        let params = new HttpParams();
        if (options && typeof(options.autoLock) !== 'undefined') { params = params.append('autoLock', options.autoLock); }

        return this.http.put<Object>(`${this.baseUrl}/${this.scope}/api/Work/WorkItem/Reclassify/${id}/${category1Id}/${category2Id}/${category3Id}`, null , { params: params });
    }

    // PUT /{scope}/api/Work/WorkItem/UnLock/{id}?lockMode={lockMode}&forceFamilyUnlock={forceFamilyUnlock}&returnWorkItem={returnWorkItem}&api-version=1.0
    public unLock(id: any, options?: { lockMode ?: any, forceFamilyUnlock ?: any, returnWorkItem ?: any}): Observable<e5Models.WorkUnLockWorkItemResponse> {
        let params = new HttpParams();
        if (options && typeof(options.lockMode) !== 'undefined') { params = params.append('lockMode', options.lockMode); }
        if (options && typeof(options.forceFamilyUnlock) !== 'undefined') { params = params.append('forceFamilyUnlock', options.forceFamilyUnlock); }
        if (options && typeof(options.returnWorkItem) !== 'undefined') { params = params.append('returnWorkItem', options.returnWorkItem); }

        return this.http.put<e5Models.WorkUnLockWorkItemResponse>(`${this.baseUrl}/${this.scope}/api/Work/WorkItem/UnLock/${id}`, null , { params: params });
    }

    // PUT /{scope}/api/Work/WorkItem/UpdateFields/{id}?autoLock={autoLock}&api-version=1.0
    public updateFields(id: any, putJson: any, options?: { autoLock ?: any}): Observable<Object> {
        let params = new HttpParams();
        if (options && typeof(options.autoLock) !== 'undefined') { params = params.append('autoLock', options.autoLock); }

        return this.http.put<Object>(`${this.baseUrl}/${this.scope}/api/Work/WorkItem/UpdateFields/${id}`, putJson , { params: params });
    }

    // GET /{scope}/api/Work/WorkItem/{id}?api-version=1.0
    public get(id: any): Observable<e5Models.WorkItemModel> {

        return this.http.get<e5Models.WorkItemModel>(`${this.baseUrl}/${this.scope}/api/Work/WorkItem/${id}` );
    }

}


@Injectable()
export class WorkItemFoundationService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // GET /{scope}/api/WorkItem/ByReference/{reference}?api-version=1.0
    public byReference(reference: any): Observable<e5Models.FoundationWorkItemFModel> {

        return this.http.get<e5Models.FoundationWorkItemFModel>(`${this.baseUrl}/${this.scope}/api/WorkItem/ByReference/${reference}` );
    }

    // POST /{scope}/api/WorkItem/Create/{category1Id}/{category2Id}/{category3Id}?api-version=1.0
    public create(category1Id: any, category2Id: any, category3Id: any, postJson: any): Observable<e5Models.FoundationWorkItemFModel> {

        return this.http.post<e5Models.FoundationWorkItemFModel>(`${this.baseUrl}/${this.scope}/api/WorkItem/Create/${category1Id}/${category2Id}/${category3Id}`, postJson );
    }

    // GET /{scope}/api/WorkItem/GenerateHtml/{workId}/{templateId}?api-version=1.0
    public generateHtml(workId: any, templateId: any): Observable<e5Models.FoundationWorkConversationMessageFModel> {

        return this.http.get<e5Models.FoundationWorkConversationMessageFModel>(`${this.baseUrl}/${this.scope}/api/WorkItem/GenerateHtml/${workId}/${templateId}` );
    }

    // GET /{scope}/api/WorkItem/GetAssignableUsers/{workId}?api-version=1.0
    public getAssignableUsers(workId: any): Observable<e5Models.UserModel[]> {

        return this.http.get<e5Models.UserModel[]>(`${this.baseUrl}/${this.scope}/api/WorkItem/GetAssignableUsers/${workId}` );
    }

    // GET /{scope}/api/WorkItem/GetDiariseReasons/{workId}?api-version=1.0
    public getDiariseReasons(workId: any): Observable<e5Models.FoundationWorkContentDiariseReasonFModel[]> {

        return this.http.get<e5Models.FoundationWorkContentDiariseReasonFModel[]>(`${this.baseUrl}/${this.scope}/api/WorkItem/GetDiariseReasons/${workId}` );
    }

    // GET /{scope}/api/WorkItem/GetNext?api-version=1.0
    public getNext(): Observable<Object> {

        return this.http.get<Object>(`${this.baseUrl}/${this.scope}/api/WorkItem/GetNext` );
    }

    // PUT /{scope}/api/WorkItem/InvokeAction/{workId}/{processAction}?api-version=1.0
    public invokeAction(workId: any, processAction: any, putJson: any): Observable<e5Models.FoundationWorkItemFModel> {

        return this.http.put<e5Models.FoundationWorkItemFModel>(`${this.baseUrl}/${this.scope}/api/WorkItem/InvokeAction/${workId}/${processAction}`, putJson );
    }

    // PUT /{scope}/api/WorkItem/Lock/{workId}?api-version=1.0
    public lock(workId: any): Observable<Object> {

        return this.http.put<Object>(`${this.baseUrl}/${this.scope}/api/WorkItem/Lock/${workId}`, null );
    }

    // PUT /{scope}/api/WorkItem/Unlock/{workId}?api-version=1.0
    public unlock(workId: any): Observable<Object> {

        return this.http.put<Object>(`${this.baseUrl}/${this.scope}/api/WorkItem/Unlock/${workId}`, null );
    }

    // PUT /{scope}/api/WorkItem/Update/{workId}?api-version=1.0
    public update(workId: any, putJson: any): Observable<e5Models.FoundationWorkItemFModel> {

        return this.http.put<e5Models.FoundationWorkItemFModel>(`${this.baseUrl}/${this.scope}/api/WorkItem/Update/${workId}`, putJson );
    }

    // GET /{scope}/api/WorkItem/{workId}?api-version=1.0
    public get(workId: any): Observable<e5Models.FoundationWorkItemFModel> {

        return this.http.get<e5Models.FoundationWorkItemFModel>(`${this.baseUrl}/${this.scope}/api/WorkItem/${workId}` );
    }

}


@Injectable()
export class WorkMenuItemFoundationService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // PUT /{scope}/api/MenuItem/InvokeMenuItem/{workId}/{menuItemId}?taskId={taskId}&menuItemCode={menuItemCode}&api-version=1.0
    public invokeMenuItem(workId: any, menuItemId: any, putJson: any, options?: { taskId ?: any, menuItemCode ?: any}): Observable<Object> {
        let params = new HttpParams();
        if (options && typeof(options.taskId) !== 'undefined') { params = params.append('taskId', options.taskId); }
        if (options && typeof(options.menuItemCode) !== 'undefined') { params = params.append('menuItemCode', options.menuItemCode); }

        return this.http.put<Object>(`${this.baseUrl}/${this.scope}/api/MenuItem/InvokeMenuItem/${workId}/${menuItemId}`, putJson , { params: params });
    }

    // GET /{scope}/api/MenuItem/{workId}?taskId={taskId}&menuItemCode={menuItemCode}&api-version=1.0
    public get(workId: any, options?: { taskId ?: any, menuItemCode ?: any}): Observable<e5Models.FoundationTaxonomyMenuItemFModel> {
        let params = new HttpParams();
        if (options && typeof(options.taskId) !== 'undefined') { params = params.append('taskId', options.taskId); }
        if (options && typeof(options.menuItemCode) !== 'undefined') { params = params.append('menuItemCode', options.menuItemCode); }

        return this.http.get<e5Models.FoundationTaxonomyMenuItemFModel>(`${this.baseUrl}/${this.scope}/api/MenuItem/${workId}` , { params: params });
    }

}


@Injectable()
export class WorkPropertyFoundationService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // PUT /{scope}/api/Property/Save?workId={workId}&propertyName={propertyName}&value={value}&api-version=1.0
    public save( options?: { workId ?: any, propertyName ?: any, value ?: any}): Observable<e5Models.FoundationWorkTaskFModel> {
        let params = new HttpParams();
        if (options && typeof(options.workId) !== 'undefined') { params = params.append('workId', options.workId); }
        if (options && typeof(options.propertyName) !== 'undefined') { params = params.append('propertyName', options.propertyName); }
        if (options && typeof(options.value) !== 'undefined') { params = params.append('value', options.value); }

        return this.http.put<e5Models.FoundationWorkTaskFModel>(`${this.baseUrl}/${this.scope}/api/Property/Save`, null , { params: params });
    }

    // GET /{scope}/api/Property/{workId}/{propertyName}?resolveLookup={resolveLookup}&api-version=1.0
    public get(workId: any, propertyName: any, options?: { resolveLookup ?: any}): Observable<e5Models.FoundationWorkPropertyValueFModel> {
        let params = new HttpParams();
        if (options && typeof(options.resolveLookup) !== 'undefined') { params = params.append('resolveLookup', options.resolveLookup); }

        return this.http.get<e5Models.FoundationWorkPropertyValueFModel>(`${this.baseUrl}/${this.scope}/api/Property/${workId}/${propertyName}` , { params: params });
    }

}


@Injectable()
export class WorkSearchFoundationService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // POST /{scope}/api/FindWorkItem/{findClassId}?attachmentTypeFilter={attachmentTypeFilter}&includeArchives={includeArchives}&includeSla={includeSla}&includeAttachmentCount={includeAttachmentCount}&includeNextDueTask={includeNextDueTask}&customProcedure={customProcedure}&select={select}&orderBy={orderBy}&siteGroupsFilter={siteGroupsFilter}&page={page}&pageSize={pageSize}&api-version=1.0
    public getFindWorkItem(findClassId: any, postJson: any, options?: { attachmentTypeFilter ?: any, includeArchives ?: any, includeSla ?: any, includeAttachmentCount ?: any, includeNextDueTask ?: any, customProcedure ?: any, select ?: any, orderBy ?: any, siteGroupsFilter ?: any, page ?: any, pageSize ?: any}): Observable<e5Models.FoundationWorkFindWorkItemResultModel> {
        let params = new HttpParams();
        if (options && typeof(options.attachmentTypeFilter) !== 'undefined') { params = params.append('attachmentTypeFilter', options.attachmentTypeFilter); }
        if (options && typeof(options.includeArchives) !== 'undefined') { params = params.append('includeArchives', options.includeArchives); }
        if (options && typeof(options.includeSla) !== 'undefined') { params = params.append('includeSla', options.includeSla); }
        if (options && typeof(options.includeAttachmentCount) !== 'undefined') { params = params.append('includeAttachmentCount', options.includeAttachmentCount); }
        if (options && typeof(options.includeNextDueTask) !== 'undefined') { params = params.append('includeNextDueTask', options.includeNextDueTask); }
        if (options && typeof(options.customProcedure) !== 'undefined') { params = params.append('customProcedure', options.customProcedure); }
        if (options && typeof(options.select) !== 'undefined') { params = params.append('select', options.select); }
        if (options && typeof(options.orderBy) !== 'undefined') { params = params.append('orderBy', options.orderBy); }
        if (options && typeof(options.siteGroupsFilter) !== 'undefined') { params = params.append('siteGroupsFilter', options.siteGroupsFilter); }
        if (options && typeof(options.page) !== 'undefined') { params = params.append('page', options.page); }
        if (options && typeof(options.pageSize) !== 'undefined') { params = params.append('pageSize', options.pageSize); }

        return this.http.post<e5Models.FoundationWorkFindWorkItemResultModel>(`${this.baseUrl}/${this.scope}/api/FindWorkItem/${findClassId}`, postJson , { params: params });
    }

}


@Injectable()
export class WorkTaskFoundationService {
    constructor(private http: HttpClient, private config: e5Config) { }

    private get baseUrl(): string {
        return this.config.settings.apiServer.baseUrl;
    }

    private get scope(): string {
        return this.config.settings.apiServer.scope;
    }


    // PUT /{scope}/api/Task/Complete/{workId}/{taskId}?api-version=1.0
    public complete(workId: any, taskId: any, putJson: any): Observable<Object> {

        return this.http.put<Object>(`${this.baseUrl}/${this.scope}/api/Task/Complete/${workId}/${taskId}`, putJson );
    }

    // GET /{scope}/api/Task/GetPrescribableTasks/{workId}?api-version=1.0
    public getPrescribableTasks(workId: any): Observable<e5Models.FoundationWorkTaskFModel[]> {

        return this.http.get<e5Models.FoundationWorkTaskFModel[]>(`${this.baseUrl}/${this.scope}/api/Task/GetPrescribableTasks/${workId}` );
    }

    // GET /{scope}/api/Task/GetPrescribedTasks/{workId}?api-version=1.0
    public getPrescribedTasks(workId: any): Observable<e5Models.FoundationWorkWorkTaskFModel[]> {

        return this.http.get<e5Models.FoundationWorkWorkTaskFModel[]>(`${this.baseUrl}/${this.scope}/api/Task/GetPrescribedTasks/${workId}` );
    }

    // PUT /{scope}/api/Task/PrescribeTask/{workId}/{taskId}?api-version=1.0
    public prescribeTask(workId: any, taskId: any): Observable<e5Models.FoundationWorkTaskFModel> {

        return this.http.put<e5Models.FoundationWorkTaskFModel>(`${this.baseUrl}/${this.scope}/api/Task/PrescribeTask/${workId}/${taskId}`, null );
    }

    // PUT /{scope}/api/Task/Save/{workId}/{taskId}?api-version=1.0
    public save(workId: any, taskId: any, putJson: any): Observable<e5Models.FoundationWorkTaskFModel> {

        return this.http.put<e5Models.FoundationWorkTaskFModel>(`${this.baseUrl}/${this.scope}/api/Task/Save/${workId}/${taskId}`, putJson );
    }

    // PUT /{scope}/api/Task/UnprescribeTask/{workId}/{taskId}?api-version=1.0
    public unprescribeTask(workId: any, taskId: any): Observable<Object> {

        return this.http.put<Object>(`${this.baseUrl}/${this.scope}/api/Task/UnprescribeTask/${workId}/${taskId}`, null );
    }

    // GET /{scope}/api/Task/{workId}?taskId={taskId}&lockWorkItem={lockWorkItem}&api-version=1.0
    public get(workId: any, options?: { taskId ?: any, lockWorkItem ?: any}): Observable<e5Models.FoundationWorkTaskFModel[]> {
        let params = new HttpParams();
        if (options && typeof(options.taskId) !== 'undefined') { params = params.append('taskId', options.taskId); }
        if (options && typeof(options.lockWorkItem) !== 'undefined') { params = params.append('lockWorkItem', options.lockWorkItem); }

        return this.http.get<e5Models.FoundationWorkTaskFModel[]>(`${this.baseUrl}/${this.scope}/api/Task/${workId}` , { params: params });
    }

}
